// import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
// import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline, CircleMarker } from "react-leaflet";
// import L from "leaflet";
// import {assignDeliveryFromAdmin} from "../service/api/orders";
//
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//     iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
//     iconUrl:       "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
//     shadowUrl:     "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
// });
//
// // ── Haversine distance in km ──────────────────────────────────────────────────
// const haversineKm = (lat1, lng1, lat2, lng2) => {
//     const R = 6371;
//     const dLat = (lat2 - lat1) * Math.PI / 180;
//     const dLng = (lng2 - lng1) * Math.PI / 180;
//     const a = Math.sin(dLat / 2) ** 2 +
//         Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
//         Math.sin(dLng / 2) ** 2;
//     return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
// };
//
// // ── Availability check for a rider against a selected order ──────────────────
// // orderPoints passed in still include picking-up orders so we can resolve
// // each rider's current picked-up order's customer coords.
// const evaluateRiderForOrder = (rider, selectedOrder, allOrderPoints, radiusKm = 3.0) => {
//     const detail = rider?.detail;
//     if (!detail || detail.status !== 1) return null;
//     if (!detail.delivery_lat || !detail.delivery_long) return null;
//
//     const riderLat = parseFloat(detail.delivery_lat);
//     const riderLng = parseFloat(detail.delivery_long);
//     const restLat  = parseFloat(selectedOrder.lat);
//     const restLng  = parseFloat(selectedOrder.lng);
//
//     const nonComplete = Number(rider.non_complete_orders ?? 0);
//
//     // ── Case 1: free rider within radius of restaurant ───────────────────────
//     if (nonComplete === 0) {
//         const dist = haversineKm(riderLat, riderLng, restLat, restLng);
//         if (dist <= radiusKm) {
//             return { case: 'case1', dist: dist.toFixed(2), isAvailable: true };
//         }
//         return { case: null, dist: dist.toFixed(2), isAvailable: false };
//     }
//
//     // ── Case 2: exactly 1 picked-up order, customer loc within radius ────────
//     if (nonComplete === 1) {
//         const pickedUpOrders = allOrderPoints.filter(o =>
//             o.orderstatus_id === 4 &&
//             (o.delivery_guy_id === rider.user_id || o.delivery_guy_id === rider.id)
//         );
//
//         if (!pickedUpOrders || pickedUpOrders.length === 0) {
//             return { case: null, dist: null, isAvailable: false };
//         }
//
//         if (pickedUpOrders.length > 1) {
//             return { case: null, dist: null, isAvailable: false };
//         }
//
//         const pickedUpOrder = pickedUpOrders[0];
//         if (pickedUpOrder) {
//             try {
//                 const loc = typeof pickedUpOrder.location === 'string'
//                     ? JSON.parse(pickedUpOrder.location)
//                     : pickedUpOrder.location;
//                 const custLat = parseFloat(loc?.lat ?? loc?.latitude);
//                 const custLng = parseFloat(loc?.lng ?? loc?.longitude);
//
//                 if (!isNaN(custLat) && !isNaN(custLng)) {
//                     const distCustToRest = haversineKm(custLat, custLng, restLat, restLng);
//                     if (distCustToRest <= radiusKm) {
//                         return {
//                             case: 'case2',
//                             dist: haversineKm(riderLat, riderLng, restLat, restLng).toFixed(2),
//                             dropDist: distCustToRest.toFixed(2),
//                             isAvailable: true
//                         };
//                     }
//                 }
//             } catch (_) {}
//         }
//
//         // Fallback: no picked-up order data — use rider's GPS as proxy
//         const dist = haversineKm(riderLat, riderLng, restLat, restLng);
//         if (dist <= radiusKm) {
//             return { case: 'case2-gps', dist: dist.toFixed(2), isAvailable: true };
//         }
//         return { case: null, dist: null, isAvailable: false };
//     }
//
//     // busy (2+ orders)
//     return { case: null, dist: null, isAvailable: false };
// };
//
// // ── Icons ─────────────────────────────────────────────────────────────────────
// const getPendingColor = (pendingCount = 0) => {
//     const c = Number(pendingCount) || 0;
//     if (c === 0) return "#2ECC71";
//     if (c === 1) return "#F7DC6F";
//     if (c === 2) return "#F39C12";
//     return "#FF6B6B";
// };
//
// const makeRiderIcon = (heading, color, highlighted = false, availCase = null) => {
//     const deg = isNaN(Number(heading)) ? 0 : Number(heading);
//     const uid = Math.random().toString(36).slice(2, 6);
//
//     // Ring color by case
//     const ringColor = availCase === 'case1' ? '#22c55e'
//         : availCase === 'case2' || availCase === 'case2-gps' ? '#3b82f6'
//             : color;
//
//     const pulseStyle = highlighted ? `
//         position:absolute;top:50%;left:50%;
//         transform:translate(-50%,-62%);
//         width:50px;height:50px;border-radius:50%;
//         border:2.5px solid ${ringColor};
//         animation:pr-${uid} 1.2s ease-out infinite;
//         pointer-events:none;
//     ` : '';
//
//     const pulseKeyframes = highlighted ? `
//         @keyframes pr-${uid}{
//             0%{transform:translate(-50%,-62%) scale(0.75);opacity:1}
//             100%{transform:translate(-50%,-62%) scale(1.8);opacity:0}
//         }
//     ` : '';
//
//     const size = highlighted ? 50 : 42;
//     const height = highlighted ? 62 : 52;
//
//     return L.divIcon({
//         html: `
//         <div style="width:${size}px;height:${height}px;position:relative;">
//             ${highlighted ? `<style>${pulseKeyframes}</style><div style="${pulseStyle}"></div>` : ''}
//             <svg viewBox="0 0 42 52" width="${size}" height="${height}" xmlns="http://www.w3.org/2000/svg">
//                 <filter id="rs-${uid}">
//                     <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="${highlighted ? ringColor : color}" flood-opacity="${highlighted ? 0.6 : 0.35}"/>
//                 </filter>
//                 <path d="M21 2C12.16 2 5 9.16 5 18c0 11.5 16 31 16 31S37 29.5 37 18C37 9.16 29.84 2 21 2z"
//                     fill="${highlighted ? ringColor : color}" filter="url(#rs-${uid})"/>
//                 <circle cx="21" cy="17" r="11" fill="white" opacity="0.92"/>
//                 <circle cx="21" cy="17" r="11" fill="none" stroke="${highlighted ? ringColor : color}" stroke-width="${highlighted ? 2 : 1.2}" opacity="0.4"/>
//                 <foreignObject x="7" y="5" width="28" height="26">
//                     <div xmlns="http://www.w3.org/1999/xhtml"
//                         style="width:28px;height:26px;display:flex;align-items:center;justify-content:center;font-size:${highlighted ? 16 : 14}px;line-height:1;transform:rotate(${deg}deg);transform-origin:center;">
//                         🛵
//                     </div>
//                 </foreignObject>
//             </svg>
//         </div>`,
//         className: "",
//         iconSize:    [size, height],
//         iconAnchor:  [size / 2, height - 2],
//         popupAnchor: [0, -(height + 4)],
//     });
// };
//
// const makeOrderIcon = (selected = false) => {
//     const uid = Math.random().toString(36).slice(2, 6);
//     const w = selected ? 54 : 44;
//     const h = selected ? 66 : 54;
//
//     const pulseStyle = selected ? `
//         position:absolute;top:50%;left:50%;
//         transform:translate(-50%,-62%);
//         width:50px;height:50px;border-radius:50%;
//         border:2px solid #6366f1;
//         animation:op-${uid} 1.4s ease-out infinite;
//         pointer-events:none;
//     ` : '';
//
//     return L.divIcon({
//         html: `
//         <div style="width:${w}px;height:${h}px;position:relative;">
//             ${selected ? `
//                 <style>@keyframes op-${uid}{0%{transform:translate(-50%,-62%) scale(0.7);opacity:0.9}100%{transform:translate(-50%,-62%) scale(1.8);opacity:0}}</style>
//                 <div style="${pulseStyle}"></div>
//             ` : ''}
//             <svg viewBox="0 0 36 46" width="${w}" height="${h}" xmlns="http://www.w3.org/2000/svg">
//                 <filter id="oi-${uid}">
//                     <feDropShadow dx="0" dy="3" stdDeviation="${selected ? 5 : 3}" flood-color="#6366f1" flood-opacity="${selected ? 0.5 : 0.3}"/>
//                 </filter>
//                 <path d="M18 2C10.3 2 4 8.3 4 16c0 10.5 14 28 14 28S32 26.5 32 16C32 8.3 25.7 2 18 2z"
//                     fill="#6366f1" filter="url(#oi-${uid})"/>
//                 <circle cx="18" cy="15" r="9.5" fill="white" opacity="0.92"/>
//                 <foreignObject x="5" y="4" width="26" height="24">
//                     <div xmlns="http://www.w3.org/1999/xhtml"
//                         style="width:26px;height:24px;display:flex;align-items:center;justify-content:center;font-size:${selected ? 15 : 13}px;">
//                         📦
//                     </div>
//                 </foreignObject>
//             </svg>
//         </div>`,
//         className: "",
//         iconSize:    [w, h],
//         iconAnchor:  [w / 2, h - 2],
//         popupAnchor: [0, -(h + 4)],
//     });
// };
//
// // ── Sub-components ────────────────────────────────────────────────────────────
// function FlyTo({ target }) {
//     const map = useMap();
//     useEffect(() => {
//         if (target) map.flyTo([target.lat, target.lng], 17, { duration: 1.5 });
//     }, [target, map]);
//     return null;
// }
//
// function FitBounds({ points }) {
//     const map = useMap();
//     useEffect(() => {
//         if (points.length > 1) {
//             map.fitBounds(L.latLngBounds(points), { padding: [48, 48], maxZoom: 15 });
//         } else if (points.length === 1) {
//             map.setView(points[0], 15);
//         }
//     }, []);
//     return null;
// }
//
// const WatchTabPanel = ({ watchoutAlerts, handleLocate, setSelectedRiderId, setSidebarTab }) => {
//     if (watchoutAlerts.length === 0) {
//         return (
//             <div style={{ padding: '44px 24px', textAlign: 'center' }}>
//                 <div style={{ fontSize: 34, marginBottom: 10 }}>✅</div>
//                 <div style={{ fontSize: 13, fontWeight: 700, color: '#15803d', marginBottom: 4 }}>
//                     All clear
//                 </div>
//                 <div style={{ fontSize: 11, color: '#94a3b8' }}>
//                     No issues detected right now
//                 </div>
//             </div>
//         );
//     }
//
//     // Separate into order alerts and rider alerts for sectioned display
//     const orderAlerts = watchoutAlerts.filter(a => a.category === 'order');
//     const riderAlerts = watchoutAlerts.filter(a => a.category === 'rider');
//
//     const renderAlert = (alert, idx) => {
//         const cfg    = WATCH_CONFIG[alert.type] || WATCH_CONFIG.stuck_transit;
//         const isHigh = alert.severity === 'high';
//         const timeMs = alert.delayMs ?? alert.stationaryMs ?? 0;
//         const timeLabel = alert.category === 'rider' ? 'stationary' : 'delayed';
//
//         const isOrderAlert = alert.category === 'order';
//
//         return (
//             <div
//                 key={`watch-${alert.type}-${alert.orderId ?? alert.riderId}-${idx}`}
//                 style={{
//                     margin: '6px 10px',
//                     borderRadius: 10,
//                     border: `1.5px solid ${isHigh ? '#fca5a5' : cfg.border}`,
//                     background: isHigh ? '#fff5f5' : cfg.bg,
//                     overflow: 'hidden',
//                     cursor: isOrderAlert ? 'default' : 'pointer',
//                     transition: 'box-shadow 0.15s',
//                 }}
//                 onClick={() => {
//                     if (!isOrderAlert) {
//                         handleLocate(alert.lng, alert.lat);
//                         setSelectedRiderId(alert.riderId);
//                         setSidebarTab('riders');
//                     }
//                 }}
//                 onMouseEnter={e => {
//                     if (!isOrderAlert) e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.1)';
//                 }}
//                 onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
//             >
//                 {/* Header strip */}
//                 <div style={{
//                     display: 'flex', alignItems: 'center', gap: 7,
//                     padding: '5px 10px',
//                     background: isHigh
//                         ? 'linear-gradient(90deg,#fee2e2,#fff5f5)'
//                         : `linear-gradient(90deg,${cfg.border}55,${cfg.bg})`,
//                     borderBottom: `1px solid ${isHigh ? '#fecaca' : cfg.border}`,
//                 }}>
//                     <span style={{ fontSize: 12 }}>{cfg.icon}</span>
//                     <span style={{
//                         fontSize: 10, fontWeight: 800, letterSpacing: '0.07em',
//                         textTransform: 'uppercase', flex: 1,
//                         color: isHigh ? '#dc2626' : cfg.text,
//                     }}>{cfg.label}</span>
//                     {isHigh && (
//                         <span style={{
//                             fontSize: 9, fontWeight: 800,
//                             background: '#dc2626', color: '#fff',
//                             borderRadius: 20, padding: '1px 7px',
//                         }}>URGENT</span>
//                     )}
//                 </div>
//
//                 {/* Body */}
//                 <div style={{ padding: '8px 10px 5px', display: 'flex', gap: 8, alignItems: 'flex-start' }}>
//
//                     {/* Avatar / icon */}
//                     {isOrderAlert ? (
//                         <div style={{
//                             width: 28, height: 28, borderRadius: 8, flexShrink: 0, marginTop: 1,
//                             background: cfg.badge, color: '#fff',
//                             display: 'flex', alignItems: 'center', justifyContent: 'center',
//                             fontSize: 13,
//                         }}>
//                             {cfg.icon}
//                         </div>
//                     ) : alert.riderPhoto ? (
//                         <img
//                             src={`https://food.totalfresh.co/assets/img/delivery/${alert.riderPhoto}`}
//                             style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, marginTop: 1 }}
//                             alt=""
//                         />
//                     ) : (
//                         <div style={{
//                             width: 28, height: 28, borderRadius: '50%', flexShrink: 0, marginTop: 1,
//                             background: cfg.badge, color: '#fff',
//                             display: 'flex', alignItems: 'center', justifyContent: 'center',
//                             fontSize: 11, fontWeight: 800,
//                         }}>
//                             {alert.riderName?.charAt(0) ?? '?'}
//                         </div>
//                     )}
//
//                     <div style={{ flex: 1, minWidth: 0 }}>
//                         {/* Title row */}
//                         <div style={{ fontWeight: 700, fontSize: 12, color: '#0f172a', marginBottom: 2 }}>
//                             {isOrderAlert ? alert.restaurant : alert.riderName}
//                         </div>
//
//                         {/* Note */}
//                         <div style={{ fontSize: 11, color: '#475569', marginBottom: 3, lineHeight: 1.4 }}>
//                             {alert.note}
//                         </div>
//
//                         {/* Sub-info */}
//                         {isOrderAlert ? (
//                             <div style={{ fontSize: 10, color: '#64748b', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
//                                 <span>📋 #{alert.orderLabel}</span>
//                                 <span>👤 {alert.customer}</span>
//                             </div>
//                         ) : (
//                             <div style={{ fontSize: 10, color: '#64748b' }}>
//                                 📍 {alert.label}
//                             </div>
//                         )}
//                     </div>
//
//                     {/* Delay/stationary timer */}
//                     <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
//                         <div style={{
//                             background: isHigh ? '#dc2626' : cfg.badge,
//                             color: '#fff', borderRadius: 20,
//                             padding: '3px 8px', fontSize: 11, fontWeight: 800,
//                             fontFamily: "'DM Mono', monospace",
//                             whiteSpace: 'nowrap',
//                         }}>
//                             ⏱ {fmtMs(timeMs)}
//                         </div>
//                         <div style={{ fontSize: 9, color: '#94a3b8' }}>{timeLabel}</div>
//                     </div>
//                 </div>
//
//                 {/* Footer hint */}
//                 <div style={{ padding: '2px 10px 6px', fontSize: 9, color: '#94a3b8' }}>
//                     {isOrderAlert
//                         ? `Order · ${alert.restaurant}`
//                         : 'Tap to locate on map →'}
//                 </div>
//             </div>
//         );
//     };
//
//     return (
//         <>
//             {/* Order delays section */}
//             {orderAlerts.length > 0 && (
//                 <>
//                     <div style={{
//                         padding: '8px 12px 5px',
//                         fontSize: 10, fontWeight: 800, letterSpacing: '0.06em',
//                         textTransform: 'uppercase', color: '#94a3b8',
//                         borderBottom: '1px solid #f1f5f9',
//                     }}>
//                         🧾 Order Delays ({orderAlerts.length})
//                     </div>
//                     {orderAlerts.map(renderAlert)}
//                 </>
//             )}
//
//             {/* Rider issues section */}
//             {riderAlerts.length > 0 && (
//                 <>
//                     <div style={{
//                         padding: '8px 12px 5px',
//                         marginTop: orderAlerts.length > 0 ? 4 : 0,
//                         fontSize: 10, fontWeight: 800, letterSpacing: '0.06em',
//                         textTransform: 'uppercase', color: '#94a3b8',
//                         borderBottom: '1px solid #f1f5f9',
//                     }}>
//                         🛵 Rider Issues ({riderAlerts.length})
//                     </div>
//                     {riderAlerts.map(renderAlert)}
//                 </>
//             )}
//         </>
//     );
// };
//
// const statusMap = {
//     1: { label: "New",        cls: "order-status--pending"   },
//     2: { label: "Accepted",   cls: "order-status--assigned"  },
//     3: { label: "Preparing",  cls: "order-status--pickedup"  },
//     4: { label: "On the Way", cls: "order-status--assigned"  },
//     5: { label: "Delivered",  cls: "order-status--completed" },
//     6: { label: "Cancelled",  cls: "order-status--cancelled" },
// };
//
// const StatusBadge = ({ status }) => {
//     const cfg = statusMap[status] || { label: `Status ${status}`, cls: "order-status--pending" };
//     return (
//         <div className={`order-status ${cfg.cls}`} style={{ marginBottom: 0, padding: "5px 10px" }}>
//             <span className="order-status__label" style={{ fontSize: 11 }}>
//                 <span className="order-status__dot" />
//                 {cfg.label}
//             </span>
//         </div>
//     );
// };
//
// const RiderPopupContent = ({ point, color, availResult }) => {
//     const detail = point?.detail || {};
//     const name   = point?.name || detail?.name || "Rider";
//
//     const caseLabel = availResult?.case === 'case1' ? 'Case 1 — Free & nearby'
//         : availResult?.case === 'case2' || availResult?.case === 'case2-gps' ? 'Case 2 — Drop-off nearby'
//             : null;
//
//     const caseBg = availResult?.case === 'case1' ? '#dcfce7'
//         : availResult?.case?.startsWith('case2') ? '#dbeafe' : null;
//
//     const caseColor = availResult?.case === 'case1' ? '#15803d'
//         : availResult?.case?.startsWith('case2') ? '#1d4ed8' : null;
//
//     return (
//         <div style={{ fontFamily: "'Inter', sans-serif", padding: "10px 14px", minWidth: 170 }}>
//             <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
//                 <div style={{
//                     width: 30, height: 30, borderRadius: "50%",
//                     background: color,
//                     display: "flex", alignItems: "center", justifyContent: "center",
//                     fontSize: 14, flexShrink: 0,
//                 }}>🛵</div>
//                 <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a" }}>{name}</div>
//             </div>
//
//             {caseLabel && (
//                 <div style={{ background: caseBg, color: caseColor, borderRadius: 6, padding: '4px 8px', fontSize: 11, fontWeight: 600, marginBottom: 6 }}>
//                     {caseLabel}
//                     {availResult?.dist && ` · ${availResult.dist} km`}
//                 </div>
//             )}
//
//             <div style={{
//                 display: "flex", alignItems: "center", gap: 6,
//                 background: "#eef2ff", borderRadius: 8, padding: "6px 10px",
//             }}>
//                 <span style={{ fontSize: 11, color: "#6366f1", fontWeight: 600 }}>Pending orders</span>
//                 <span style={{
//                     marginLeft: "auto",
//                     background: "#6366f1", color: "#fff",
//                     borderRadius: 20, padding: "1px 8px",
//                     fontSize: 12, fontWeight: 800,
//                     fontFamily: "'DM Mono', monospace",
//                 }}>{point?.non_complete_orders ?? 0}</span>
//             </div>
//         </div>
//     );
// };
//
// const OrderPopupContent = ({ order }) => (
//     <div style={{ fontFamily: "'Inter', sans-serif" }}>
//         <div style={{
//             display: "flex", alignItems: "center", gap: 10,
//             padding: "11px 14px 10px",
//             borderBottom: "3px solid #6366f1",
//             background: "linear-gradient(135deg, #eef2ff 0%, #ffffff 100%)",
//         }}>
//             <div style={{
//                 width: 36, height: 36, borderRadius: "50%",
//                 background: "#6366f1",
//                 display: "flex", alignItems: "center", justifyContent: "center",
//                 fontSize: 16, flexShrink: 0,
//                 boxShadow: "0 2px 8px #6366f155",
//             }}>📦</div>
//             <div style={{ flex: 1, minWidth: 0 }}>
//                 <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a" }}>
//                     {order.restaurant || "Restaurant"}
//                 </div>
//                 <div style={{ fontSize: 10, color: "#6366f1", fontFamily: "'DM Mono', monospace", marginTop: 2 }}>
//                     #{order.id}
//                 </div>
//             </div>
//         </div>
//         <div style={{ padding: "8px 14px 4px" }}>
//             {order.name && (
//                 <div className="tm-popup-row">
//                     <span className="tm-popup-row-icon">👤</span>
//                     <span className="tm-popup-row-label">Customer </span>
//                     <span className="tm-popup-row-value" style={{ fontWeight: 600 }}>{order.name}</span>
//                 </div>
//             )}
//             {order.address && (
//                 <div className="tm-popup-row">
//                     <span className="tm-popup-row-icon">📍</span>
//                     <span className="tm-popup-row-label">To </span>
//                     <span className="tm-popup-row-value" style={{ fontSize: 11, lineHeight: 1.4 }}>{order.address}</span>
//                 </div>
//             )}
//         </div>
//         <div style={{ padding: "4px 14px 8px", fontSize: 11, color: '#6366f1', fontWeight: 600 }}>
//             Click to see available riders
//         </div>
//         <div style={{ padding: "0 14px 10px" }}>
//             <StatusBadge status={order.status} />
//         </div>
//     </div>
// );
//
// function HoverMarker({ position, icon, children, onClick }) {
//     const markerRef = useRef(null);
//     return (
//         <Marker
//             position={position}
//             icon={icon}
//             ref={markerRef}
//             eventHandlers={{
//                 mouseover: () => markerRef.current?.openPopup(),
//                 mouseout:  () => markerRef.current?.closePopup(),
//                 click:     (e) => {
//                     L.DomEvent.stopPropagation(e);
//                     onClick?.();
//                     markerRef.current?.openPopup();
//                 },
//             }}
//         >
//             <Popup autoPan={false} keepInView={false} closeButton={false}>
//                 {children}
//             </Popup>
//         </Marker>
//     );
// }
//
// const ElapsedTimer = ({ createdAt }) => {
//     const [elapsed, setElapsed] = useState('');
//
//     useEffect(() => {
//         const calc = () => {
//             if (!createdAt) return;
//             const diffMs = Date.now() - new Date(createdAt).getTime();
//             const totalSec = Math.floor(diffMs / 1000);
//             const h = Math.floor(totalSec / 3600);
//             const m = Math.floor((totalSec % 3600) / 60);
//             const s = totalSec % 60;
//             if (h > 0) setElapsed(`${h}h ${m}m`);
//             else if (m > 0) setElapsed(`${m}m ${s}s`);
//             else setElapsed(`${s}s`);
//         };
//         calc();
//         const id = setInterval(calc, 1000);
//         return () => clearInterval(id);
//     }, [createdAt]);
//
//     if (!elapsed) return null;
//
//     const isLate = (Date.now() - new Date(createdAt).getTime()) > 30 * 60 * 1000;
//
//     return (
//         <span style={{
//             display: 'inline-flex', alignItems: 'center', gap: 3,
//             marginTop: 3, fontSize: 10, fontWeight: 700,
//             fontFamily: "'DM Mono', monospace",
//             color: isLate ? '#dc2626' : '#6366f1',
//         }}>
//             ⏱ {elapsed}
//         </span>
//     );
// };
//
//
// const fmtMs = (ms) => {
//     const m = Math.floor(ms / 60000);
//     const s = Math.floor((ms % 60000) / 1000);
//     return m > 0 ? `${m}m ${s}s` : `${s}s`;
// };
//
// const WATCH_CONFIG = {
//     prep_overdue: {
//         icon: '⏰', label: 'Overdue Prep',
//         bg: '#fff1f2', border: '#fda4af', text: '#9f1239', badge: '#f43f5e',
//     },
//     wait_dropoff: {
//         icon: '🏠', label: 'At Drop-off',
//         bg: '#fef2f2', border: '#fecaca', text: '#991b1b', badge: '#ef4444',
//     },
//     wait_restaurant: {
//         icon: '🍽️', label: 'At Restaurant',
//         bg: '#fef9c3', border: '#fde68a', text: '#92400e', badge: '#f59e0b',
//     },
//     prep_delayed: {
//         icon: '🕐', label: 'Prep Delayed',
//         bg: '#fff7ed', border: '#fed7aa', text: '#7c2d12', badge: '#f97316',
//     },
//     new_delayed: {
//         icon: '🆕', label: 'New — No Accept',
//         bg: '#faf5ff', border: '#e9d5ff', text: '#581c87', badge: '#a855f7',
//     },
//     stuck_transit: {
//         icon: '🚦', label: 'Stuck in Transit',
//         bg: '#f0f9ff', border: '#bae6fd', text: '#0c4a6e', badge: '#0ea5e9',
//     },
// };
//
//
// // ── Main component ────────────────────────────────────────────────────────────
// const TrackingMap = ({ points = [], orderPoints = [],  radiusKm = 3.0  }) => {
//     const [flyTarget, setFlyTarget]       = useState(null);
//     const [open, setOpen]         = useState(false);
//     const [expanded, setExpanded] = useState(false);
//     const [sidebarTab, setSidebarTab]     = useState('riders');
//     const [showBoth, setShowBoth]         = useState(false);
//     const [selectedOrderId, setSelectedOrderId] = useState(null);
//     const [selectedRiderId, setSelectedRiderId] = useState(null);
//
//
//     const [assigningRiderId, setAssigningRiderId] = useState(null);
//     const [assignedMap, setAssignedMap] = useState({}); // { orderId: riderId }
//
//
//
//     const showRiders = showBoth || sidebarTab === 'riders';
//     const showOrders = showBoth || sidebarTab === 'orders';
//
//     const validPoints = useMemo(() =>
//             points.filter(
//                 (p) => p?.detail?.delivery_lat != null && p?.detail?.delivery_long != null
//             ),
//         [points]);
//
//     const formattedOrders = useMemo(() =>
//             orderPoints
//                 .filter((o) => [1, 2].includes(Number(o.orderstatus_id)))
//                 .map((o) => {
//                     try {
//                         const loc = typeof o.location === "string" ? JSON.parse(o.location) : o.location;
//
//                         return {
//                             id:         o.order_id,
//                             name:       o.customer_name,
//                             lat:        parseFloat(o?.restaurant_latitude),
//                             lng:        parseFloat(o?.restaurant_longitude),
//                             address:    loc?.address,
//                             status:     Number(o.orderstatus_id),
//                             restaurant: o.restaurant_name,
//                             createdAt:  o.created_at,
//                             customerId: o.customer_id
//                         };
//                     } catch {
//                         return null;
//                     }
//                 })
//                 .filter((o) => o && !isNaN(o.lat) && !isNaN(o.lng)),
//         [orderPoints]
//     );
//
//
//     const handleAssign = useCallback(async (orderId, userId, customerId) => {
//         setAssigningRiderId(userId);
//         try {
//             await assignDeliveryFromAdmin(orderId, userId, customerId);
//             setAssignedMap(prev => ({ ...prev, [orderId]: userId }));
//         } catch (e) {
//             console.error('Assign failed', e);
//         } finally {
//             setAssigningRiderId(null);
//         }
//     }, []);
//
//     // ── Compute which riders are highlighted for the selected order ──────────
//     const riderAvailability = useMemo(() => {
//         if (!selectedOrderId) return {};
//         const order = formattedOrders.find(o => o.id === selectedOrderId);
//         if (!order) return {};
//
//         const result = {};
//         validPoints.forEach((rider) => {
//             const av = evaluateRiderForOrder(rider, order, orderPoints, radiusKm);
//             if (av) result[rider.user_id] = av;
//         });
//         return result;
//     }, [selectedOrderId, formattedOrders, validPoints, orderPoints]);
//
//     // Riders that are highlighted (available for selected order)
//     const highlightedRiderIds = useMemo(() =>
//             Object.entries(riderAvailability)
//                 .filter(([, av]) => av.isAvailable)
//                 .map(([id]) => Number(id)),
//         [riderAvailability]
//     );
//
//
//     const riderLineData = useMemo(() => {
//         if (!selectedRiderId) return null;
//         const rider = validPoints.find(p => p.user_id === selectedRiderId);
//         if (!rider) return null;
//
//         const riderLat = parseFloat(rider.detail.delivery_lat);
//         const riderLng = parseFloat(rider.detail.delivery_long);
//
//         // Strict match with type coercion fix
//         const activeOrder = orderPoints.find(o =>
//             (o.delivery_guy_id === rider.user_id || o.delivery_guy_id === rider.id) &&
//             [3, 4].includes(o.orderstatus_id)
//         );
//
//         if (!activeOrder) return null;
//
//         let dropLat, dropLng, dropLabel, dropType;
//
//         if (activeOrder.orderstatus_id === 4) {
//             try {
//                 const loc = typeof activeOrder.location === 'string'
//                     ? JSON.parse(activeOrder.location)
//                     : activeOrder.location;
//                 dropLat = parseFloat(loc?.lat ?? loc?.latitude);
//                 dropLng = parseFloat(loc?.lng ?? loc?.longitude);
//                 dropLabel = activeOrder.customer_name || 'Customer';
//                 dropType = 'customer';
//
//                 console.log("loc: ", loc)
//
//             } catch (_) { return null; }
//         } else {
//             dropLat = parseFloat(activeOrder.restaurant_latitude);
//             dropLng = parseFloat(activeOrder.restaurant_longitude);
//             dropLabel = activeOrder.restaurant_name || 'Restaurant';
//             dropType = 'restaurant';
//         }
//
//         if (isNaN(dropLat) || isNaN(dropLng)) return null;
//
//         const response =  {
//             riderPos: [riderLat, riderLng],
//             dropPos: [dropLat, dropLng],
//             dropLabel,
//             dropType,
//             riderName: rider.name || rider.detail?.name,
//         };
//
//         return response;
//     }, [selectedRiderId, validPoints, orderPoints]);
//
//     const orderRiderLines = useMemo(() => {
//         if (!selectedOrderId || sidebarTab !== 'orders') return [];
//         const order = formattedOrders.find(o => o.id === selectedOrderId);
//         if (!order) return [];
//
//         return highlightedRiderIds
//             .map(riderId => {
//                 const rider = validPoints.find(p => p.user_id === riderId);
//                 if (!rider) return null;
//                 const av = riderAvailability[riderId];
//
//                 const riderPos = [
//                     parseFloat(rider.detail.delivery_lat),
//                     parseFloat(rider.detail.delivery_long),
//                 ];
//
//                 if (av?.case === 'case1') {
//                     // Free rider — line goes to the restaurant
//                     return {
//                         riderId,
//                         riderPos,
//                         destPos: [order.lat, order.lng],
//                         case: 'case1',
//                     };
//                 }
//
//                 if (av?.case === 'case2' || av?.case === 'case2-gps') {
//                     const pickedUpOrders = orderPoints.filter(o =>
//                         o.orderstatus_id === 4
//                     );
//
//                     // console.log("pickedUpOrders: ", pickedUpOrders)
//
//                     const pickedUpOrder = pickedUpOrders?.find(order => {
//                         const orderRiderId = Number(order.delivery_guy_id);
//
//                         // console.log({
//                         //     order_id: order.order_id,
//                         //     orderRiderId,
//                         //     riderId,
//                         //     matched: orderRiderId === riderId,
//                         // });
//
//                         return orderRiderId === riderId;
//                     });
//
//                     // console.log("rider: ", rider.user_id)
//                     // console.log("pikupOrder: ", pickedUpOrders)
//
//                     if (pickedUpOrder) {
//                         try {
//                             const loc = typeof pickedUpOrder.location === 'string'
//                                 ? JSON.parse(pickedUpOrder.location)
//                                 : pickedUpOrder.location;
//                             const custLat = parseFloat(loc?.lat ?? loc?.latitude);
//                             const custLng = parseFloat(loc?.lng ?? loc?.longitude);
//                             if (!isNaN(custLat) && !isNaN(custLng)) {
//                                 return {
//                                     riderId,
//                                     riderPos,
//                                     destPos: [custLat, custLng],
//                                     case: 'case2',
//                                     dropLabel: pickedUpOrder.customer_name || 'Customer',
//                                 };
//                             }
//                         } catch { /* fall through */ }
//                     }
//
//                     // case2-gps or no customer coords — rider is preparing, line to restaurant
//                     return {
//                         riderId,
//                         riderPos,
//                         destPos: [order.lat, order.lng],
//                         case: 'case2-gps',
//                         dropLabel: 'Restaurant (preparing)',
//                     };
//                 }
//
//                 return null;
//             })
//             .filter(Boolean);
//     }, [selectedOrderId, sidebarTab, formattedOrders, highlightedRiderIds, validPoints, riderAvailability, orderPoints]);
//
//     // Parse '2026-06-12 13:50:59' → ms since epoch
//     const parseOrderTime = (str) => {
//         if (!str) return null;
//         const ms = new Date(str.replace(' ', 'T')).getTime();
//         return isNaN(ms) ? null : ms;
//     };
//
//     // Parse live.ready_at (unix seconds string) → ms since epoch
//     const parseReadyAt = (val) => {
//         if (!val) return null;
//         const n = Number(val);
//         if (isNaN(n) || n === 0) return null;
//         // Unix seconds → ms  (ready_at values are ~1.78B = year 2026, safe to treat as seconds)
//         return n * 1000;
//     };
//
//
//     const riderPositionHistory = useRef({});
//
//     useEffect(() => {
//         const now = Date.now();
//         validPoints.forEach((rider) => {
//             const uid = rider.user_id;
//             const lat = parseFloat(rider.detail?.delivery_lat);
//             const lng = parseFloat(rider.detail?.delivery_long);
//             if (isNaN(lat) || isNaN(lng)) return;
//
//             const prev = riderPositionHistory.current[uid];
//             if (!prev) {
//                 riderPositionHistory.current[uid] = { lat, lng, recordedAt: now };
//                 return;
//             }
//
//             const moved = haversineKm(prev.lat, prev.lng, lat, lng) > 0.05; // >50m = moved
//             if (moved) {
//                 // Rider moved — reset their stationary clock
//                 riderPositionHistory.current[uid] = { lat, lng, recordedAt: now };
//             }
//             // If not moved, keep old recordedAt — stationaryMs keeps growing
//         });
//     }, [validPoints]);
//
//
//     // ── Watchout thresholds ───────────────────────────────────────────────────────
//     const STUCK_TRANSIT_MS   = 3 * 60 * 1000;  // 3 min — not near any known location
//     const WAIT_RESTAURANT_MS = 3 * 60 * 1000;  // 3 min — at restaurant, not moving
//     const WAIT_DROPOFF_MS    = 5 * 60 * 1000;  // 5 min — at customer, not moving
//     const NEAR_KM            = 0.15;           // 150m radius = "at location"
//     const NEW_ORDER_DELAY_MS = 5 * 60 * 1000; // 5 min — store hasn't accepted
//     const PREP_DEFAULT_MS    = 10 * 60 * 1000; // 10 min default prep (no live object)
//     const PREP_LIVE_MS       = 15 * 60 * 1000; // 15 min fallback (live exists, no ready_at)
//
//     const PRIORITY = {
//         prep_overdue:    1,  // past ready_at time — most urgent order issue
//         wait_dropoff:    2,  // rider stuck at customer
//         wait_restaurant: 3,  // rider stuck at restaurant
//         prep_delayed:    4,  // preparing but no ready_at, time exceeded
//         new_delayed:     5,  // new order not accepted by store
//         stuck_transit:   6,  // rider not moving in unknown location
//     };
//
//     const watchoutAlerts = useMemo(() => {
//         const now    = Date.now();
//         const nowSec = now / 1000;
//         const alerts = [];
//
//         // ── ORDER-BASED ALERTS ────────────────────────────────────────────────────
//         orderPoints.forEach((o) => {
//             const statusId  = Number(o.orderstatus_id);
//             const createdMs = parseOrderTime(o.created_at);
//             const ageMs     = createdMs ? now - createdMs : null;
//
//             const orderMeta = {
//                 orderId:    o.order_id,
//                 orderLabel: o.unique_order_id?.slice(10) || String(o.order_id),
//                 restaurant: o.restaurant_name || 'Restaurant',
//                 customer:   o.customer_name   || 'Customer',
//             };
//
//             // ── 1. Preparing order past ready_at (MOST URGENT) ───────────────────
//             if (statusId === 2) {
//                 const readyAtMs  = parseReadyAt(o.live?.ready_at);
//                 const hasLive    = !!o.live;
//
//                 if (readyAtMs) {
//                     // We have an explicit ready_at — alert if now is past it
//                     const overdueMs = now - readyAtMs;
//                     if (overdueMs > 0) {
//                         alerts.push({
//                             type:      'prep_overdue',
//                             severity:  overdueMs >= 5 * 60 * 1000 ? 'high' : 'medium',
//                             category:  'order',
//                             priority:  PRIORITY.prep_overdue,
//                             delayMs:   overdueMs,
//                             ...orderMeta,
//                             note:      'Past estimated ready time',
//                         });
//                     }
//                 } else if (ageMs !== null) {
//                     // No ready_at — use time-based fallback
//                     const threshold = hasLive ? PREP_LIVE_MS : PREP_DEFAULT_MS;
//                     if (ageMs >= threshold) {
//                         alerts.push({
//                             type:      'prep_delayed',
//                             severity:  ageMs >= threshold + 5 * 60 * 1000 ? 'high' : 'medium',
//                             category:  'order',
//                             priority:  PRIORITY.prep_delayed,
//                             delayMs:   ageMs,
//                             ...orderMeta,
//                             note:      hasLive
//                                 ? 'Preparing >15 min — restaurant slow?'
//                                 : 'Preparing >10 min — no update from restaurant',
//                         });
//                     }
//                 }
//             }
//
//             // ── 2. New order not accepted by store after 5 min ───────────────────
//             if (statusId === 1 && ageMs !== null && ageMs >= NEW_ORDER_DELAY_MS) {
//                 alerts.push({
//                     type:      'new_delayed',
//                     severity:  ageMs >= 10 * 60 * 1000 ? 'high' : 'medium',
//                     category:  'order',
//                     priority:  PRIORITY.new_delayed,
//                     delayMs:   ageMs,
//                     ...orderMeta,
//                     note:      'Store hasn\'t accepted — needs attention',
//                 });
//             }
//         });
//
//         // ── RIDER-BASED ALERTS ────────────────────────────────────────────────────
//         validPoints.forEach((rider) => {
//             const uid        = rider.user_id;
//             const name       = rider.name || rider.detail?.name || 'Rider';
//             const lat        = parseFloat(rider.detail?.delivery_lat);
//             const lng        = parseFloat(rider.detail?.delivery_long);
//             if (isNaN(lat) || isNaN(lng)) return;
//
//             const hist         = riderPositionHistory.current[uid];
//             const stationaryMs = hist ? now - hist.recordedAt : 0;
//             const nonComplete  = Number(rider.non_complete_orders ?? 0);
//
//             const riderMeta = {
//                 riderId:    uid,
//                 riderName:  name,
//                 riderPhoto: rider.detail?.photo,
//                 lat, lng,
//                 stationaryMs,
//             };
//
//
//
//             // Orders belonging to this rider
//             const riderOrders = orderPoints.filter(o =>
//                 Number(o.delivery_guy_id) === uid || o.delivery_guy_id === rider.id
//             );
//
//
//             // ── 3. Waiting at restaurant ─────────────────────────────────────────
//             const atRestaurantOrder = riderOrders.find(o => {
//                 if (![3, 4].includes(Number(o.orderstatus_id))) return false;
//                 const rLat = parseFloat(o.restaurant_latitude);
//                 const rLng = parseFloat(o.restaurant_longitude);
//                 return !isNaN(rLat) && haversineKm(lat, lng, rLat, rLng) <= NEAR_KM;
//             });
//
//             if (atRestaurantOrder && stationaryMs >= WAIT_RESTAURANT_MS) {
//                 alerts.push({
//                     type:     'wait_restaurant',
//                     severity: stationaryMs >= 6 * 60 * 1000 ? 'high' : 'medium',
//                     category: 'rider',
//                     priority: PRIORITY.wait_restaurant,
//                     orderId:  atRestaurantOrder.order_id,
//                     label:    atRestaurantOrder.restaurant_name || 'Restaurant',
//                     note:     'Waiting at restaurant — food not ready?',
//                     ...riderMeta,
//                 });
//                 return; // one alert per rider, most specific first
//             }
//
//             // ── 4. Long wait at drop-off ─────────────────────────────────────────
//             const atDropoffOrder = riderOrders.find(o => {
//                 if (Number(o.orderstatus_id) !== 4) return false;
//                 try {
//                     const loc  = typeof o.location === 'string' ? JSON.parse(o.location) : o.location;
//                     const cLat = parseFloat(loc?.lat ?? loc?.latitude);
//                     const cLng = parseFloat(loc?.lng ?? loc?.longitude);
//                     return !isNaN(cLat) && haversineKm(lat, lng, cLat, cLng) <= NEAR_KM;
//                 } catch { return false; }
//             });
//
//             if (atDropoffOrder && stationaryMs >= WAIT_DROPOFF_MS) {
//                 alerts.push({
//                     type:     'wait_dropoff',
//                     severity: stationaryMs >= 10 * 60 * 1000 ? 'high' : 'medium',
//                     category: 'rider',
//                     priority: PRIORITY.wait_dropoff,
//                     orderId:  atDropoffOrder.order_id,
//                     label:    atDropoffOrder.customer_name || 'Customer',
//                     note:     'At drop-off — customer not answering?',
//                     ...riderMeta,
//                 });
//                 return;
//             }
//
//
//             console.log("riderMeta: ", riderMeta, ", | Non completed orders: ", nonComplete, ",  | STUCK_TRANSIT_MS: ", STUCK_TRANSIT_MS)
//
//             // ── 5. Stuck in transit ──────────────────────────────────────────────
//             if (nonComplete > 0 && stationaryMs >= STUCK_TRANSIT_MS) {
//                 const nearKnown = riderOrders.some(o => {
//                     const rLat = parseFloat(o.restaurant_latitude);
//                     const rLng = parseFloat(o.restaurant_longitude);
//                     if (!isNaN(rLat) && haversineKm(lat, lng, rLat, rLng) <= NEAR_KM) return true;
//                     try {
//                         const loc  = typeof o.location === 'string' ? JSON.parse(o.location) : o.location;
//                         const cLat = parseFloat(loc?.lat ?? loc?.latitude);
//                         const cLng = parseFloat(loc?.lng ?? loc?.longitude);
//                         return !isNaN(cLat) && haversineKm(lat, lng, cLat, cLng) <= NEAR_KM;
//                     } catch { return false; }
//                 });
//
//                 if (!nearKnown) {
//                     alerts.push({
//                         type:     'stuck_transit',
//                         severity: stationaryMs >= 8 * 60 * 1000 ? 'high' : 'medium',
//                         category: 'rider',
//                         priority: PRIORITY.stuck_transit,
//                         orderId:  null,
//                         label:    `${nonComplete} pending order${nonComplete > 1 ? 's' : ''}`,
//                         note:     'Not moving — may be stuck or stopped',
//                         ...riderMeta,
//                     });
//                 }
//             }
//         });
//
//         // Sort: high severity first → priority → longest delay/stationary
//         return alerts.sort((a, b) => {
//             if (a.severity !== b.severity) return a.severity === 'high' ? -1 : 1;
//             if (a.priority !== b.priority) return a.priority - b.priority;
//             const aTime = a.delayMs ?? a.stationaryMs ?? 0;
//             const bTime = b.delayMs ?? b.stationaryMs ?? 0;
//             return bTime - aTime;
//         });
//     }, [validPoints, orderPoints]); // eslint-disable-line react-hooks/exhaustive-deps
//
//
//     const allBoundsPoints = [
//         ...(showRiders ? validPoints.map((p) => [p.detail.delivery_lat, p.detail.delivery_long]) : []),
//         ...(showOrders ? formattedOrders.map((o) => [o.lat, o.lng]) : []),
//         ...(sidebarTab === 'orders' && selectedOrderId
//             ? highlightedRiderIds
//                 .map(id => validPoints.find(p => p.user_id === id))
//                 .filter(Boolean)
//                 .map(p => [p.detail.delivery_lat, p.detail.delivery_long])
//             : []),
//     ];
//
//     const handleLocate = useCallback((lng, lat) => {
//         setFlyTarget({ lat, lng, _t: Date.now() });
//     }, []);
//
//     const handleOrderClick = useCallback((orderId) => {
//         setSelectedOrderId(prev => prev === orderId ? null : orderId);
//     }, []);
//
//     const mapContent = useMemo(() => (
//         <MapContainer
//             center={[16.4346, 80.5662]}
//             zoom={15}
//             style={{ width: "100%", height: "100%" }}
//             attributionControl={false}
//         >
//             <TileLayer
//                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                 attribution='&copy; OpenStreetMap'
//             />
//             {allBoundsPoints.length > 0 && <FitBounds points={allBoundsPoints} />}
//             {flyTarget && <FlyTo target={flyTarget} key={flyTarget._t} />}
//
//             {/* Rider markers */}
//             {showRiders && validPoints.map((p, idx) => {
//                 const av    = sidebarTab === 'orders' ? riderAvailability[p.user_id] : null;
//                 const isHL  = sidebarTab === 'orders' && highlightedRiderIds.includes(p.user_id);
//                 // const color = isHL
//                 //     ? (av?.case === 'case1' ? '#22c55e' : '#3b82f6')
//                 //     : getPendingColor(p?.non_complete_orders);
//
//                 const color = getPendingColor(p?.non_complete_orders);
//
//                 // If an order is selected, dim non-highlighted riders
//                 return (
//                     <div key={`rider-wrap-${idx}`}>
//                         <HoverMarker
//                             position={[p.detail.delivery_lat, p.detail.delivery_long]}
//                             icon={makeRiderIcon(p.detail.heading, color, isHL, av?.case)}
//                         >
//                             <RiderPopupContent point={p} color={color} availResult={isHL ? av : null} />
//                         </HoverMarker>
//                     </div>
//                 );
//             })}
//
//             {/* Order markers */}
//             {showOrders && formattedOrders.map((o, idx) => {
//                 const isSelected = selectedOrderId === o.id;
//                 return (
//                     <HoverMarker
//                         key={`order-${idx}`}
//                         position={[o.lat, o.lng]}
//                         icon={makeOrderIcon(isSelected)}
//                         onClick={() => handleOrderClick(o.id)}
//                     >
//                         <OrderPopupContent order={o} />
//                     </HoverMarker>
//                 );
//             })}
//
//             {/* Available rider markers for selected order — orders tab only */}
//             {sidebarTab === 'orders' && selectedOrderId && highlightedRiderIds.map((riderId) => {
//                 const p = validPoints.find(r => r.user_id === riderId);
//                 if (!p) return null;
//                 const av = riderAvailability[p.user_id];
//                 const color = getPendingColor(p?.non_complete_orders);
//                 return (
//                     <HoverMarker
//                         key={`avail-rider-${riderId}`}
//                         position={[p.detail.delivery_lat, p.detail.delivery_long]}
//                         icon={makeRiderIcon(p.detail.heading, color, true, av?.case)}
//                     >
//                         <RiderPopupContent point={p} color={color} availResult={av} />
//                     </HoverMarker>
//                 );
//             })}
//
//
//             {/* Rider → drop-off line */}
//             {riderLineData && (
//                 <>
//                     <Polyline
//                         positions={[riderLineData.riderPos, riderLineData.dropPos]}
//                         pathOptions={{
//                             color: riderLineData.dropType === 'customer' ? '#6366f1' : '#f59e0b',
//                             weight: 3,
//                             dashArray: '8 6',
//                             opacity: 0.85,
//                         }}
//                     />
//                     <CircleMarker
//                         center={riderLineData.dropPos}
//                         radius={10}
//                         pathOptions={{
//                             color: riderLineData.dropType === 'customer' ? '#6366f1' : '#f59e0b',
//                             fillColor: riderLineData.dropType === 'customer' ? '#eef2ff' : '#fefce8',
//                             fillOpacity: 1,
//                             weight: 2.5,
//                         }}
//                     >
//                         <Popup closeButton={false} autoPan={false}>
//                             <div style={{ fontFamily: 'Inter, sans-serif', padding: '6px 10px', fontSize: 12 }}>
//                                 <div style={{ fontWeight: 700, color: '#0f172a' }}>
//                                     {riderLineData.dropType === 'customer' ? '🏠' : '🍽️'} {riderLineData.dropLabel}
//                                 </div>
//                                 <div style={{ fontSize: 10, color: '#64748b', marginTop: 2 }}>
//                                     {riderLineData.dropType === 'customer' ? 'Drop-off destination' : 'Pickup restaurant'}
//                                 </div>
//                             </div>
//                         </Popup>
//                     </CircleMarker>
//                 </>
//             )}
//
//             {/* Available rider → restaurant lines (orders tab) */}
//             {orderRiderLines.map((line) => (
//                 <React.Fragment key={`order-line-${line.riderId}`}>
//                     <Polyline
//                         positions={[line.riderPos, line.destPos]}
//                         pathOptions={{
//                             color: line.case === 'case1' ? '#22c55e' : '#3b82f6',
//                             weight: 2.5,
//                             dashArray: '6 5',
//                             opacity: 0.8,
//                         }}
//                     />
//                     <CircleMarker
//                         center={line.destPos}
//                         radius={7}
//                         pathOptions={{
//                             color: line.case === 'case1' ? '#22c55e' : '#3b82f6',
//                             fillColor: line.case === 'case1' ? '#dcfce7' : '#dbeafe',
//                             fillOpacity: 1,
//                             weight: 2,
//                         }}
//                     >
//                         <Popup closeButton={false} autoPan={false}>
//                             <div style={{ fontFamily: 'Inter, sans-serif', padding: '6px 10px', fontSize: 12 }}>
//                                 <div style={{ fontWeight: 700, color: '#0f172a' }}>
//                                     {line.case === 'case1' ? '🍽️ Restaurant' : `🏠 ${line.dropLabel}`}
//                                 </div>
//                                 <div style={{ fontSize: 10, color: '#64748b', marginTop: 2 }}>
//                                     {line.case === 'case1' ? 'Rider heading here' : 'Current drop-off'}
//                                 </div>
//                             </div>
//                         </Popup>
//                     </CircleMarker>
//                 </React.Fragment>
//             ))}
//         </MapContainer>
//     ), [validPoints, formattedOrders, orderRiderLines, riderLineData, flyTarget, allBoundsPoints, showRiders, showOrders, sidebarTab, selectedOrderId, highlightedRiderIds, riderAvailability]);
//
//     // Sidebar available riders count for selected order
//     const availableForSelected = highlightedRiderIds.length;
//
//
//     const BUBBLE_KEY = 'eagleview_bubble_pos';
//     const defaultPos = { right: 24, bottom: 24 };
//
//     const [bubblePos, setBubblePos] = useState(() => {
//         try {
//             const saved = localStorage.getItem(BUBBLE_KEY);
//             return saved ? JSON.parse(saved) : defaultPos;
//         } catch { return defaultPos; }
//     });
//     const draggingRef = useRef(false);
//     const dragOffset  = useRef({ x: 0, y: 0 });
//
//     const onBubbleMouseDown = useCallback((e) => {
//         e.preventDefault();
//         draggingRef.current = false;
//         const startX = e.clientX;
//         const startY = e.clientY;
//         const startLeft = e.currentTarget.getBoundingClientRect().left;
//         const startTop  = e.currentTarget.getBoundingClientRect().top;
//         dragOffset.current = { startX, startY, startLeft, startTop };
//
//         const onMove = (me) => {
//             const dx = me.clientX - startX;
//             const dy = me.clientY - startY;
//             if (Math.abs(dx) > 3 || Math.abs(dy) > 3) draggingRef.current = true;
//             if (!draggingRef.current) return;
//
//             const newLeft = Math.max(0, Math.min(window.innerWidth - 110, startLeft + dx));
//             const newTop  = Math.max(0, Math.min(window.innerHeight - 80, startTop + dy));
//             const newPos  = { left: newLeft, top: newTop, right: 'auto', bottom: 'auto' };
//             setBubblePos(newPos);
//         };
//
//         const onUp = () => {
//             window.removeEventListener('mousemove', onMove);
//             window.removeEventListener('mouseup', onUp);
//             setBubblePos(prev => {
//                 try { localStorage.setItem(BUBBLE_KEY, JSON.stringify(prev)); } catch {}
//                 return prev;
//             });
//         };
//
//         window.addEventListener('mousemove', onMove);
//         window.addEventListener('mouseup', onUp);
//     }, []);
//
//     return (
//         <>
//             {/* ── Floating bubble ── */}
//             <div
//                 className="map-float-bubble"
//                 style={{ ...bubblePos, cursor: 'grab', userSelect: 'none' }}
//                 onMouseDown={onBubbleMouseDown}
//                 onClick={() => { if (!draggingRef.current) setOpen(true); }}
//             >
//                 <div className="map-float-preview" style={{ pointerEvents: 'none' }}>
//                     <MapContainer
//                         center={[16.4346, 80.5662]}
//                         zoom={12}
//                         style={{ width: '100%', height: '100%' }}
//                         zoomControl={false}
//                         dragging={false}
//                         scrollWheelZoom={false}
//                         doubleClickZoom={false}
//                         touchZoom={false}
//                         attributionControl={false}
//                     >
//                         <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
//                         {validPoints.map((p, idx) => (
//                             <Marker
//                                 key={idx}
//                                 position={[p.detail.delivery_lat, p.detail.delivery_long]}
//                                 icon={makeRiderIcon(p.detail.heading, getPendingColor(p?.non_complete_orders))}
//                             />
//                         ))}
//                     </MapContainer>
//                 </div>
//                 <div className="map-float-label">
//                     🗺️ Eagle View
//                     <span className="map-float-count">{validPoints.length}</span>
//                 </div>
//             </div>
//
//             {/* ── Full modal ── */}
//             {open && (
//                 <div className="map-modal-overlay" onClick={() => {
//                     setOpen(false);
//                     setExpanded(false);
//                 }}>
//                     <div
//                         className="map-modal-inner"
//                         onClick={(e) => e.stopPropagation()}
//                         style={expanded ? {
//                             width: '100vw',
//                             height: '100vh',
//                             maxWidth: '100vw',
//                             maxHeight: '100vh',
//                             borderRadius: 0,
//                             top: 0,
//                             left: 0,
//                             margin: 0,
//                             position: 'fixed',
//                             inset: 0,
//                         } : undefined}
//                     >
//                         {/* Close button */}
//                         <button
//                             className="map-modal-close"
//                             onClick={() => {
//                                 setOpen(false);
//                                 setExpanded(false);
//                             }}
//                             title="Minimize"
//                             style={{right: expanded ? 56 : undefined}}
//                         >
//                             ✕
//                         </button>
//
//                         {/* Expand / collapse toggle button */}
//                         <button
//                             className="map-modal-close"
//                             onClick={() => setExpanded(e => !e)}
//                             title={expanded ? 'Exit full screen' : 'Full screen'}
//                             style={{right: 12}}
//                         >
//                             {expanded
//                                 ? /* collapse icon — two inward arrows */
//                                 <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
//                                      stroke="currentColor" strokeWidth="2.2"
//                                      strokeLinecap="round" strokeLinejoin="round">
//                                     <polyline points="4 14 10 14 10 20"/>
//                                     <polyline points="20 10 14 10 14 4"/>
//                                     <line x1="10" y1="14" x2="3" y2="21"/>
//                                     <line x1="21" y1="3" x2="14" y2="10"/>
//                                 </svg>
//                                 : /* expand icon — two outward arrows */
//                                 <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
//                                      stroke="currentColor" strokeWidth="2.2"
//                                      strokeLinecap="round" strokeLinejoin="round">
//                                     <polyline points="15 3 21 3 21 9"/>
//                                     <polyline points="9 21 3 21 3 15"/>
//                                     <line x1="21" y1="3" x2="14" y2="10"/>
//                                     <line x1="3" y1="21" x2="10" y2="14"/>
//                                 </svg>
//                             }
//                         </button>
//
//                         <div className="map-dashboard-wrapper" style={{height: '100%', margin: 0, borderRadius: 0}}>
//                             <div className="map-container-main">{mapContent}</div>
//
//                             <div className="map-sidebar">
//                                 <div className="section-header" style={{
//                                     padding: '16px 20px',
//                                     background: '#fff',
//                                     borderBottom: '1px solid #e2e8f0',
//                                     justifyContent: 'space-between'
//                                 }}>
//                                     <p className="eagleview-title">Eagle View</p>
//                                     <span className="eagleview-count">{validPoints.length}</span>
//                                 </div>
//
//                                 {/* Selected order info strip */}
//                                 {selectedOrderId && sidebarTab === 'orders' && (
//                                     <div style={{
//                                         padding: '10px 16px',
//                                         background: '#eef2ff',
//                                         borderBottom: '1px solid #c7d2fe',
//                                         display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//                                     }}>
//                                         <div>
//                                             <div style={{fontSize: 11, fontWeight: 700, color: '#4338ca'}}>
//                                                 {formattedOrders.find(o => o.id === selectedOrderId)?.restaurant}
//                                             </div>
//                                             <div style={{fontSize: 10, color: '#6366f1', marginTop: 1}}>
//                                                 {availableForSelected} rider{availableForSelected !== 1 ? 's' : ''} available
//                                                 nearby
//                                             </div>
//                                         </div>
//                                         <button
//                                             onClick={() => setSelectedOrderId(null)}
//                                             style={{
//                                                 background: 'none',
//                                                 border: 'none',
//                                                 cursor: 'pointer',
//                                                 fontSize: 16,
//                                                 color: '#6366f1',
//                                                 lineHeight: 1
//                                             }}
//                                             title="Clear selection"
//                                         >×
//                                         </button>
//                                     </div>
//                                 )}
//
//                                 {/* Legend strip when order selected */}
//                                 {selectedOrderId && sidebarTab === 'orders' && (
//                                     <div style={{
//                                         padding: '6px 16px',
//                                         background: '#f8fafc',
//                                         borderBottom: '1px solid #e2e8f0',
//                                         display: 'flex',
//                                         gap: 12
//                                     }}>
//                                         <span style={{
//                                             fontSize: 10,
//                                             color: '#64748b',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: 4
//                                         }}>
//                                             <span style={{
//                                                 width: 8,
//                                                 height: 8,
//                                                 borderRadius: '50%',
//                                                 background: '#22c55e',
//                                                 display: 'inline-block'
//                                             }}/>
//                                             Case 1: free & nearby
//                                         </span>
//                                         <span style={{
//                                             fontSize: 10,
//                                             color: '#64748b',
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: 4
//                                         }}>
//                                             <span style={{
//                                                 width: 8,
//                                                 height: 8,
//                                                 borderRadius: '50%',
//                                                 background: '#3b82f6',
//                                                 display: 'inline-block'
//                                             }}/>
//                                             Case 2: drop-off nearby
//                                         </span>
//                                     </div>
//                                 )}
//
//                                 {/* Tabs */}
//                                 <div style={{display: 'flex', borderBottom: '1px solid #e2e8f0', background: '#fff'}}>
//                                     {['riders', 'orders', 'watch'].map((t) => (
//                                         <button
//                                             key={t}
//                                             onClick={() => {
//                                                 if (sidebarTab === t && !showBoth) setShowBoth(true);
//                                                 else {
//                                                     setSidebarTab(t);
//                                                     setShowBoth(false);
//                                                 }
//                                             }}
//                                             style={{
//                                                 flex: 1, padding: '9px 0', fontSize: 12, fontWeight: 700,
//                                                 fontFamily: 'Inter, sans-serif', letterSpacing: '0.04em',
//                                                 textTransform: 'uppercase', border: 'none',
//                                                 borderBottom: sidebarTab === t ? '2px solid #6366f1' : '2px solid transparent',
//                                                 background: 'none',
//                                                 color: sidebarTab === t ? '#6366f1' : '#94a3b8',
//                                                 cursor: 'pointer', transition: 'color 0.15s',
//                                             }}
//                                         >
//                                             {t === 'riders'
//                                                 ? `🛵 Riders (${validPoints.length})`
//                                                 : t === 'orders'
//                                                     ? `📦 Orders (${formattedOrders.length})`
//                                                     : (
//                                                         <span style={{
//                                                             display: 'inline-flex',
//                                                             alignItems: 'center',
//                                                             gap: 4
//                                                         }}>
//                                                             ⚠️ Watch
//                                                             {watchoutAlerts.length > 0 && (
//                                                                 <span style={{
//                                                                     background: watchoutAlerts.some(a => a.severity === 'high') ? '#dc2626' : '#f59e0b',
//                                                                     color: '#fff',
//                                                                     borderRadius: 20,
//                                                                     padding: '0 5px',
//                                                                     fontSize: 9,
//                                                                     fontWeight: 800,
//                                                                     lineHeight: '14px',
//                                                                     minWidth: 14,
//                                                                     textAlign: 'center',
//                                                                     display: 'inline-block',
//                                                                 }}>{watchoutAlerts.length}</span>
//                                                             )}
//                                                         </span>
//                                                     )}
//                                         </button>
//                                     ))}
//                                 </div>
//
//                                 <div className="indicator-list">
//                                     {/* Riders tab */}
//                                     {sidebarTab === 'riders' && (() => {
//                                         return validPoints.map((p, idx) => {
//                                             const isSelected = selectedRiderId === p.user_id;
//                                             const color = getPendingColor(p?.non_complete_orders);
//
//                                             return (
//                                                 <div
//                                                     key={`list-${idx}`}
//                                                     className="indicator-item"
//                                                     style={{
//                                                         borderColor: isSelected ? '#f59e0b' : color,
//                                                         borderWidth: isSelected ? 2 : 1,
//                                                         opacity: 1,
//                                                         background: isSelected ? '#fefce8' : undefined,
//                                                     }}
//                                                     onClick={() => {
//                                                         handleLocate(p?.detail?.delivery_long, p?.detail?.delivery_lat);
//                                                         setSelectedRiderId(prev => prev === p.user_id ? null : p.user_id);
//                                                     }}
//                                                 >
//                                                     {p?.detail?.photo ? (
//                                                         <div className="dp-avatar">
//                                                             <img
//                                                                 src={"https://food.totalfresh.co/assets/img/delivery/" + p?.detail?.photo}
//                                                                 className="dp-avatar" alt=""/>
//                                                         </div>
//                                                     ) : (
//                                                         <span className="dot" style={{backgroundColor: color}}>
//                                                             {(p?.detail?.name || p?.name || "?").charAt(0)}
//                                                         </span>
//                                                     )}
//                                                     <div className="item-info">
//                                                         <div className="item-name">{p?.name}</div>
//                                                         <div style={{fontSize: 11, color: '#64748b'}}>
//                                                             Pending: {p?.non_complete_orders}
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             );
//                                         });
//                                     })()}
//
//                                     {/* Orders tab */}
//                                     {sidebarTab === 'orders' && formattedOrders.map((o, idx) => {
//                                         const isSelected = selectedOrderId === o.id;
//
//                                         // Build rider breakdown for this order when selected
//                                         const case1Riders = isSelected
//                                             ? validPoints.filter(p => riderAvailability[p.user_id]?.case === 'case1')
//                                             : [];
//                                         const case2Riders = isSelected
//                                             ? validPoints.filter(p =>
//                                                 riderAvailability[p.user_id]?.case === 'case2' ||
//                                                 riderAvailability[p.user_id]?.case === 'case2-gps'
//                                             )
//                                             : [];
//
//                                         return (
//                                             <div
//                                                 key={`order-list-${idx}`}
//                                                 className="indicator-item"
//                                                 style={{
//                                                     borderColor: isSelected ? '#6366f1' : '#e2e8f0',
//                                                     borderWidth: isSelected ? 2 : 1,
//                                                     background: isSelected ? '#eef2ff' : undefined,
//                                                     flexDirection: 'column',
//                                                     alignItems: 'stretch',
//                                                     gap: 0,
//                                                     padding: 0,
//                                                 }}
//                                             >
//                                                 {/* Order row */}
//                                                 <div
//                                                     style={{
//                                                         display: 'flex',
//                                                         alignItems: 'center',
//                                                         gap: 10,
//                                                         padding: '10px 12px',
//                                                         cursor: 'pointer'
//                                                     }}
//                                                     onClick={() => {
//                                                         handleLocate(o.lng, o.lat);
//                                                         handleOrderClick(o.id);
//                                                     }}
//                                                 >
//                                                     <span className="dot" style={{
//                                                         backgroundColor: '#6366f1',
//                                                         color: '#fff',
//                                                         fontSize: 13,
//                                                         flexShrink: 0
//                                                     }}>📦</span>
//                                                     <div className="item-info" style={{flex: 1, minWidth: 0}}>
//                                                         <div style={{
//                                                             display: 'flex',
//                                                             alignItems: 'center',
//                                                             gap: 6,
//                                                             marginBottom: 2
//                                                         }}>
//                                                             <div className="item-name"
//                                                                  style={{fontSize: 12}}>{o.restaurant}</div>
//                                                             <span style={{
//                                                                 fontSize: 9,
//                                                                 fontWeight: 700,
//                                                                 letterSpacing: '0.05em',
//                                                                 textTransform: 'uppercase',
//                                                                 borderRadius: 10,
//                                                                 padding: '2px 7px',
//                                                                 background: o.status === 1 ? '#fef9c3' : '#e0f2fe',
//                                                                 color: o.status === 1 ? '#a16207' : '#0369a1',
//                                                                 border: `1px solid ${o.status === 1 ? '#fde68a' : '#bae6fd'}`,
//                                                                 flexShrink: 0,
//                                                             }}>
//             {o.status === 1 ? '🆕 New' : '🍳 Preparing'}
//         </span>
//                                                         </div>
//                                                         <div style={{fontSize: 11, color: '#64748b'}}>{o.name}</div>
//                                                         <div style={{fontSize: 10, color: '#94a3b8', marginTop: 1}}>
//                                                             {o.address?.slice(0, 40)}{o.address?.length > 40 ? '…' : ''}
//                                                         </div>
//                                                         <ElapsedTimer createdAt={o.createdAt}/> {/* 👈 */}
//                                                         {!isSelected && (
//                                                             <div style={{fontSize: 10, color: '#a5b4fc', marginTop: 2}}>
//                                                                 Tap to see available riders
//                                                             </div>
//                                                         )}
//                                                     </div>
//                                                     {isSelected && (
//                                                         <div style={{
//                                                             flexShrink: 0,
//                                                             background: availableForSelected > 0 ? '#6366f1' : '#94a3b8',
//                                                             color: '#fff',
//                                                             borderRadius: 20,
//                                                             padding: '2px 8px',
//                                                             fontSize: 11,
//                                                             fontWeight: 700,
//                                                         }}>
//                                                             {availableForSelected}
//                                                         </div>
//                                                     )}
//                                                 </div>
//
//                                                 {/* Inline rider availability panel */}
//                                                 {isSelected && (
//                                                     <div style={{
//                                                         borderTop: '1px solid #c7d2fe',
//                                                         background: '#f5f3ff',
//                                                         padding: '10px 12px',
//                                                         display: 'flex',
//                                                         flexDirection: 'column',
//                                                         gap: 8,
//                                                     }}>
//                                                         {availableForSelected === 0 ? (
//                                                             <div style={{
//                                                                 fontSize: 11,
//                                                                 color: '#94a3b8',
//                                                                 textAlign: 'center',
//                                                                 padding: '4px 0'
//                                                             }}>
//                                                                 No riders available nearby
//                                                             </div>
//                                                         ) : (
//                                                             <>
//                                                                 {case1Riders.length > 0 && (
//                                                                     <div>
//                                                                         <div style={{
//                                                                             fontSize: 10,
//                                                                             fontWeight: 700,
//                                                                             color: '#15803d',
//                                                                             marginBottom: 5,
//                                                                             letterSpacing: '0.04em',
//                                                                             textTransform: 'uppercase'
//                                                                         }}>
//                                                                             🟢 Case 1 — Free &amp; nearby
//                                                                             ({case1Riders.length})
//                                                                         </div>
//                                                                         <div style={{
//                                                                             display: 'flex',
//                                                                             flexWrap: 'wrap',
//                                                                             gap: 6
//                                                                         }}>
//                                                                             {case1Riders.map(p => {
//                                                                                 const av = riderAvailability[p.user_id];
//                                                                                 const isAssigned = assignedMap[o.id] === p.user_id;
//                                                                                 const isAssigning = assigningRiderId === p.user_id;
//                                                                                 return (
//                                                                                     <div
//                                                                                         key={p.user_id}
//                                                                                         style={{
//                                                                                             display: 'flex',
//                                                                                             alignItems: 'center',
//                                                                                             gap: 5,
//                                                                                             background: '#dcfce7',
//                                                                                             border: '1px solid #86efac',
//                                                                                             borderRadius: 20,
//                                                                                             padding: '3px 6px 3px 6px',
//                                                                                             fontSize: 11,
//                                                                                         }}
//                                                                                     >
//                                                                                         {p?.detail?.photo ? (
//                                                                                             <img
//                                                                                                 src={"https://food.totalfresh.co/assets/img/delivery/" + p.detail.photo}
//                                                                                                 style={{
//                                                                                                     width: 18,
//                                                                                                     height: 18,
//                                                                                                     borderRadius: '50%',
//                                                                                                     objectFit: 'cover'
//                                                                                                 }}
//                                                                                                 alt=""
//                                                                                                 onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
//                                                                                             />
//                                                                                         ) : (
//                                                                                             <div
//                                                                                                 onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
//                                                                                                 style={{
//                                                                                                     width: 18,
//                                                                                                     height: 18,
//                                                                                                     borderRadius: '50%',
//                                                                                                     background: '#22c55e',
//                                                                                                     color: '#fff',
//                                                                                                     display: 'flex',
//                                                                                                     alignItems: 'center',
//                                                                                                     justifyContent: 'center',
//                                                                                                     fontSize: 9,
//                                                                                                     fontWeight: 700,
//                                                                                                     flexShrink: 0,
//                                                                                                     cursor: 'pointer',
//                                                                                                 }}
//                                                                                             >
//                                                                                                 {(p?.name || '?').charAt(0)}
//                                                                                             </div>
//                                                                                         )}
//                                                                                         <span
//                                                                                             onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
//                                                                                             style={{
//                                                                                                 color: '#15803d',
//                                                                                                 fontWeight: 600,
//                                                                                                 cursor: 'pointer'
//                                                                                             }}
//                                                                                         >{p?.name}</span>
//                                                                                         {av?.dist && <span style={{
//                                                                                             color: '#16a34a',
//                                                                                             fontSize: 10
//                                                                                         }}>{av.dist}km</span>}
//                                                                                         <button
//                                                                                             onClick={() => handleAssign(o.id, p.user_id, o.customerId)}
//                                                                                             disabled={isAssigning || isAssigned}
//                                                                                             style={{
//                                                                                                 marginLeft: 2,
//                                                                                                 background: isAssigned ? '#86efac' : '#22c55e',
//                                                                                                 color: '#fff',
//                                                                                                 border: 'none',
//                                                                                                 borderRadius: 20,
//                                                                                                 padding: '2px 7px',
//                                                                                                 fontSize: 10,
//                                                                                                 fontWeight: 700,
//                                                                                                 cursor: isAssigned ? 'default' : 'pointer',
//                                                                                                 opacity: isAssigning ? 0.6 : 1,
//                                                                                                 transition: 'all 0.15s',
//                                                                                             }}
//                                                                                         >
//                                                                                             {isAssigned ? '✓' : isAssigning ? '...' : 'Assign'}
//                                                                                         </button>
//                                                                                     </div>
//                                                                                 );
//                                                                             })}
//                                                                         </div>
//                                                                     </div>
//                                                                 )}
//
//                                                                 {case2Riders.length > 0 && (
//                                                                     <div>
//                                                                         <div style={{
//                                                                             fontSize: 10,
//                                                                             fontWeight: 700,
//                                                                             color: '#1d4ed8',
//                                                                             marginBottom: 5,
//                                                                             letterSpacing: '0.04em',
//                                                                             textTransform: 'uppercase'
//                                                                         }}>
//                                                                             🔵 Case 2 — Drop-off nearby
//                                                                             ({case2Riders.length})
//                                                                         </div>
//                                                                         <div style={{
//                                                                             display: 'flex',
//                                                                             flexWrap: 'wrap',
//                                                                             gap: 6
//                                                                         }}>
//                                                                             {case2Riders.map(p => {
//                                                                                 const av = riderAvailability[p.user_id];
//                                                                                 const isAssigned = assignedMap[o.id] === p.user_id;
//                                                                                 const isAssigning = assigningRiderId === p.user_id;
//                                                                                 return (
//                                                                                     <div
//                                                                                         key={p.user_id}
//                                                                                         style={{
//                                                                                             display: 'flex',
//                                                                                             alignItems: 'center',
//                                                                                             gap: 5,
//                                                                                             background: '#dbeafe',
//                                                                                             border: '1px solid #93c5fd',
//                                                                                             borderRadius: 20,
//                                                                                             padding: '3px 6px 3px 6px',
//                                                                                             fontSize: 11,
//                                                                                         }}
//                                                                                     >
//                                                                                         {p?.detail?.photo ? (
//                                                                                             <img
//                                                                                                 src={"https://food.totalfresh.co/assets/img/delivery/" + p.detail.photo}
//                                                                                                 style={{
//                                                                                                     width: 18,
//                                                                                                     height: 18,
//                                                                                                     borderRadius: '50%',
//                                                                                                     objectFit: 'cover'
//                                                                                                 }}
//                                                                                                 alt=""
//                                                                                                 onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
//                                                                                             />
//                                                                                         ) : (
//                                                                                             <div
//                                                                                                 onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
//                                                                                                 style={{
//                                                                                                     width: 18,
//                                                                                                     height: 18,
//                                                                                                     borderRadius: '50%',
//                                                                                                     background: '#3b82f6',
//                                                                                                     color: '#fff',
//                                                                                                     display: 'flex',
//                                                                                                     alignItems: 'center',
//                                                                                                     justifyContent: 'center',
//                                                                                                     fontSize: 9,
//                                                                                                     fontWeight: 700,
//                                                                                                     flexShrink: 0,
//                                                                                                     cursor: 'pointer',
//                                                                                                 }}
//                                                                                             >
//                                                                                                 {(p?.name || '?').charAt(0)}
//                                                                                             </div>
//                                                                                         )}
//                                                                                         <span
//                                                                                             onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
//                                                                                             style={{
//                                                                                                 color: '#1d4ed8',
//                                                                                                 fontWeight: 600,
//                                                                                                 cursor: 'pointer'
//                                                                                             }}
//                                                                                         >{p?.name}</span>
//                                                                                         {av?.dropDist && <span style={{
//                                                                                             color: '#2563eb',
//                                                                                             fontSize: 10
//                                                                                         }}>{av.dropDist}km drop</span>}
//                                                                                         <button
//                                                                                             onClick={() => handleAssign(o.id, p.user_id, o.customerId)}
//                                                                                             disabled={isAssigning || isAssigned}
//                                                                                             style={{
//                                                                                                 marginLeft: 2,
//                                                                                                 background: isAssigned ? '#93c5fd' : '#3b82f6',
//                                                                                                 color: '#fff',
//                                                                                                 border: 'none',
//                                                                                                 borderRadius: 20,
//                                                                                                 padding: '2px 7px',
//                                                                                                 fontSize: 10,
//                                                                                                 fontWeight: 700,
//                                                                                                 cursor: isAssigned ? 'default' : 'pointer',
//                                                                                                 opacity: isAssigning ? 0.6 : 1,
//                                                                                                 transition: 'all 0.15s',
//                                                                                             }}
//                                                                                         >
//                                                                                             {isAssigned ? '✓' : isAssigning ? '...' : 'Assign'}
//                                                                                         </button>
//                                                                                     </div>
//                                                                                 );
//                                                                             })}
//                                                                         </div>
//                                                                     </div>
//                                                                 )}
//                                                             </>
//                                                         )}
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         );
//                                     })}
//
//                                     {sidebarTab === 'orders' && formattedOrders.length === 0 && (
//                                         <div style={{
//                                             padding: 24,
//                                             textAlign: 'center',
//                                             color: '#94a3b8',
//                                             fontSize: 13
//                                         }}>No active orders</div>
//                                     )}
//
//                                     {sidebarTab === 'watch' && (
//                                         <WatchTabPanel
//                                             watchoutAlerts={watchoutAlerts}
//                                             handleLocate={handleLocate}
//                                             setSelectedRiderId={setSelectedRiderId}
//                                             setSidebarTab={setSidebarTab}
//                                         />
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };
//
// export default TrackingMap;




import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline, CircleMarker } from "react-leaflet";
import L from "leaflet";
import {assignDeliveryFromAdmin} from "../service/api/orders";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl:       "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl:     "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

// ── Haversine distance in km ──────────────────────────────────────────────────
const haversineKm = (lat1, lng1, lat2, lng2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(dLat / 2) ** 2 +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

// ── Availability check for a rider against a selected order ──────────────────
// orderPoints passed in still include picking-up orders so we can resolve
// each rider's current picked-up order's customer coords.
const evaluateRiderForOrder = (rider, selectedOrder, allOrderPoints, radiusKm = 3.0) => {
    const detail = rider?.detail;
    if (!detail || detail.status !== 1) return null;
    if (!detail.delivery_lat || !detail.delivery_long) return null;

    const riderLat = parseFloat(detail.delivery_lat);
    const riderLng = parseFloat(detail.delivery_long);
    const restLat  = parseFloat(selectedOrder.lat);
    const restLng  = parseFloat(selectedOrder.lng);

    const nonComplete = Number(rider.non_complete_orders ?? 0);

    // ── Case 1: free rider within radius of restaurant ───────────────────────
    if (nonComplete === 0) {
        const dist = haversineKm(riderLat, riderLng, restLat, restLng);
        if (dist <= radiusKm) {
            return { case: 'case1', dist: dist.toFixed(2), isAvailable: true };
        }
        return { case: null, dist: dist.toFixed(2), isAvailable: false };
    }

    // ── Case 2: exactly 1 picked-up order, customer loc within radius ────────
    if (nonComplete === 1) {
        const pickedUpOrders = allOrderPoints.filter(o =>
            o.orderstatus_id === 4 &&
            (o.delivery_guy_id === rider.user_id || o.delivery_guy_id === rider.id)
        );

        if (!pickedUpOrders || pickedUpOrders.length === 0) {
            return { case: null, dist: null, isAvailable: false };
        }

        if (pickedUpOrders.length > 1) {
            return { case: null, dist: null, isAvailable: false };
        }

        const pickedUpOrder = pickedUpOrders[0];
        if (pickedUpOrder) {
            try {
                const loc = typeof pickedUpOrder.location === 'string'
                    ? JSON.parse(pickedUpOrder.location)
                    : pickedUpOrder.location;
                const custLat = parseFloat(loc?.lat ?? loc?.latitude);
                const custLng = parseFloat(loc?.lng ?? loc?.longitude);

                if (!isNaN(custLat) && !isNaN(custLng)) {
                    const distCustToRest = haversineKm(custLat, custLng, restLat, restLng);
                    if (distCustToRest <= radiusKm) {
                        return {
                            case: 'case2',
                            dist: haversineKm(riderLat, riderLng, restLat, restLng).toFixed(2),
                            dropDist: distCustToRest.toFixed(2),
                            isAvailable: true
                        };
                    }
                }
            } catch (_) {}
        }

        // Fallback: no picked-up order data — use rider's GPS as proxy
        const dist = haversineKm(riderLat, riderLng, restLat, restLng);
        if (dist <= radiusKm) {
            return { case: 'case2-gps', dist: dist.toFixed(2), isAvailable: true };
        }
        return { case: null, dist: null, isAvailable: false };
    }

    // busy (2+ orders)
    return { case: null, dist: null, isAvailable: false };
};

// ── Icons ─────────────────────────────────────────────────────────────────────
const getPendingColor = (pendingCount = 0) => {
    const c = Number(pendingCount) || 0;
    if (c === 0) return "#2ECC71";
    if (c === 1) return "#F7DC6F";
    if (c === 2) return "#F39C12";
    return "#FF6B6B";
};

const makeRiderIcon = (heading, color, highlighted = false, availCase = null) => {
    const deg = isNaN(Number(heading)) ? 0 : Number(heading);
    const uid = Math.random().toString(36).slice(2, 6);

    // Ring color by case
    const ringColor = availCase === 'case1' ? '#22c55e'
        : availCase === 'case2' || availCase === 'case2-gps' ? '#3b82f6'
            : color;

    const pulseStyle = highlighted ? `
        position:absolute;top:50%;left:50%;
        transform:translate(-50%,-62%);
        width:50px;height:50px;border-radius:50%;
        border:2.5px solid ${ringColor};
        animation:pr-${uid} 1.2s ease-out infinite;
        pointer-events:none;
    ` : '';

    const pulseKeyframes = highlighted ? `
        @keyframes pr-${uid}{
            0%{transform:translate(-50%,-62%) scale(0.75);opacity:1}
            100%{transform:translate(-50%,-62%) scale(1.8);opacity:0}
        }
    ` : '';

    const size = highlighted ? 50 : 42;
    const height = highlighted ? 62 : 52;

    return L.divIcon({
        html: `
        <div style="width:${size}px;height:${height}px;position:relative;">
            ${highlighted ? `<style>${pulseKeyframes}</style><div style="${pulseStyle}"></div>` : ''}
            <svg viewBox="0 0 42 52" width="${size}" height="${height}" xmlns="http://www.w3.org/2000/svg">
                <filter id="rs-${uid}">
                    <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="${highlighted ? ringColor : color}" flood-opacity="${highlighted ? 0.6 : 0.35}"/>
                </filter>
                <path d="M21 2C12.16 2 5 9.16 5 18c0 11.5 16 31 16 31S37 29.5 37 18C37 9.16 29.84 2 21 2z"
                    fill="${highlighted ? ringColor : color}" filter="url(#rs-${uid})"/>
                <circle cx="21" cy="17" r="11" fill="white" opacity="0.92"/>
                <circle cx="21" cy="17" r="11" fill="none" stroke="${highlighted ? ringColor : color}" stroke-width="${highlighted ? 2 : 1.2}" opacity="0.4"/>
                <foreignObject x="7" y="5" width="28" height="26">
                    <div xmlns="http://www.w3.org/1999/xhtml"
                        style="width:28px;height:26px;display:flex;align-items:center;justify-content:center;font-size:${highlighted ? 16 : 14}px;line-height:1;transform:rotate(${deg}deg);transform-origin:center;">
                        🛵
                    </div>
                </foreignObject>
            </svg>
        </div>`,
        className: "",
        iconSize:    [size, height],
        iconAnchor:  [size / 2, height - 2],
        popupAnchor: [0, -(height + 4)],
    });
};

const makeOrderIcon = (selected = false) => {
    const uid = Math.random().toString(36).slice(2, 6);
    const w = selected ? 54 : 44;
    const h = selected ? 66 : 54;

    const pulseStyle = selected ? `
        position:absolute;top:50%;left:50%;
        transform:translate(-50%,-62%);
        width:50px;height:50px;border-radius:50%;
        border:2px solid #6366f1;
        animation:op-${uid} 1.4s ease-out infinite;
        pointer-events:none;
    ` : '';

    return L.divIcon({
        html: `
        <div style="width:${w}px;height:${h}px;position:relative;">
            ${selected ? `
                <style>@keyframes op-${uid}{0%{transform:translate(-50%,-62%) scale(0.7);opacity:0.9}100%{transform:translate(-50%,-62%) scale(1.8);opacity:0}}</style>
                <div style="${pulseStyle}"></div>
            ` : ''}
            <svg viewBox="0 0 36 46" width="${w}" height="${h}" xmlns="http://www.w3.org/2000/svg">
                <filter id="oi-${uid}">
                    <feDropShadow dx="0" dy="3" stdDeviation="${selected ? 5 : 3}" flood-color="#6366f1" flood-opacity="${selected ? 0.5 : 0.3}"/>
                </filter>
                <path d="M18 2C10.3 2 4 8.3 4 16c0 10.5 14 28 14 28S32 26.5 32 16C32 8.3 25.7 2 18 2z"
                    fill="#6366f1" filter="url(#oi-${uid})"/>
                <circle cx="18" cy="15" r="9.5" fill="white" opacity="0.92"/>
                <foreignObject x="5" y="4" width="26" height="24">
                    <div xmlns="http://www.w3.org/1999/xhtml"
                        style="width:26px;height:24px;display:flex;align-items:center;justify-content:center;font-size:${selected ? 15 : 13}px;">
                        📦
                    </div>
                </foreignObject>
            </svg>
        </div>`,
        className: "",
        iconSize:    [w, h],
        iconAnchor:  [w / 2, h - 2],
        popupAnchor: [0, -(h + 4)],
    });
};

// ── Sub-components ────────────────────────────────────────────────────────────
function FlyTo({ target }) {
    const map = useMap();
    useEffect(() => {
        if (target) map.flyTo([target.lat, target.lng], 17, { duration: 1.5 });
    }, [target, map]);
    return null;
}

function FitBounds({ points }) {
    const map = useMap();
    useEffect(() => {
        if (points.length > 1) {
            map.fitBounds(L.latLngBounds(points), { padding: [48, 48], maxZoom: 15 });
        } else if (points.length === 1) {
            map.setView(points[0], 15);
        }
    }, []);
    return null;
}

const WatchTabPanel = ({ watchoutAlerts, handleLocate, setSelectedRiderId, setSidebarTab }) => {
    if (watchoutAlerts.length === 0) {
        return (
            <div style={{ padding: '44px 24px', textAlign: 'center' }}>
                <div style={{ fontSize: 34, marginBottom: 10 }}>✅</div>
                <div style={{ fontSize: 13, fontWeight: 700, color: '#15803d', marginBottom: 4 }}>
                    All clear
                </div>
                <div style={{ fontSize: 11, color: '#94a3b8' }}>
                    No issues detected right now
                </div>
            </div>
        );
    }

    // Separate into order alerts and rider alerts for sectioned display
    const orderAlerts = watchoutAlerts.filter(a => a.category === 'order');
    const riderAlerts = watchoutAlerts.filter(a => a.category === 'rider');

    const renderAlert = (alert, idx) => {
        const cfg    = WATCH_CONFIG[alert.type] || WATCH_CONFIG.stuck_transit;
        const isHigh = alert.severity === 'high';
        const timeMs = alert.delayMs ?? alert.stationaryMs ?? 0;
        const timeLabel = alert.category === 'rider' ? 'stationary' : 'delayed';

        const isOrderAlert = alert.category === 'order';

        return (
            <div
                key={`watch-${alert.type}-${alert.orderId ?? alert.riderId}-${idx}`}
                style={{
                    margin: '6px 10px',
                    borderRadius: 10,
                    border: `1.5px solid ${isHigh ? '#fca5a5' : cfg.border}`,
                    background: isHigh ? '#fff5f5' : cfg.bg,
                    overflow: 'hidden',
                    cursor: isOrderAlert ? 'default' : 'pointer',
                    transition: 'box-shadow 0.15s',
                }}
                onClick={() => {
                    if (!isOrderAlert) {
                        handleLocate(alert.lng, alert.lat);
                        setSelectedRiderId(alert.riderId);
                        setSidebarTab('riders');
                    }
                }}
                onMouseEnter={e => {
                    if (!isOrderAlert) e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
            >
                {/* Header strip */}
                <div style={{
                    display: 'flex', alignItems: 'center', gap: 7,
                    padding: '5px 10px',
                    background: isHigh
                        ? 'linear-gradient(90deg,#fee2e2,#fff5f5)'
                        : `linear-gradient(90deg,${cfg.border}55,${cfg.bg})`,
                    borderBottom: `1px solid ${isHigh ? '#fecaca' : cfg.border}`,
                }}>
                    <span style={{ fontSize: 12 }}>{cfg.icon}</span>
                    <span style={{
                        fontSize: 10, fontWeight: 800, letterSpacing: '0.07em',
                        textTransform: 'uppercase', flex: 1,
                        color: isHigh ? '#dc2626' : cfg.text,
                    }}>{cfg.label}</span>
                    {isHigh && (
                        <span style={{
                            fontSize: 9, fontWeight: 800,
                            background: '#dc2626', color: '#fff',
                            borderRadius: 20, padding: '1px 7px',
                        }}>URGENT</span>
                    )}
                </div>

                {/* Body */}
                <div style={{ padding: '8px 10px 5px', display: 'flex', gap: 8, alignItems: 'flex-start' }}>

                    {/* Avatar / icon */}
                    {isOrderAlert ? (
                        <div style={{
                            width: 28, height: 28, borderRadius: 8, flexShrink: 0, marginTop: 1,
                            background: cfg.badge, color: '#fff',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 13,
                        }}>
                            {cfg.icon}
                        </div>
                    ) : alert.riderPhoto ? (
                        <img
                            src={`https://food.totalfresh.co/assets/img/delivery/${alert.riderPhoto}`}
                            style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, marginTop: 1 }}
                            alt=""
                        />
                    ) : (
                        <div style={{
                            width: 28, height: 28, borderRadius: '50%', flexShrink: 0, marginTop: 1,
                            background: cfg.badge, color: '#fff',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 11, fontWeight: 800,
                        }}>
                            {alert.riderName?.charAt(0) ?? '?'}
                        </div>
                    )}

                    <div style={{ flex: 1, minWidth: 0 }}>
                        {/* Title row */}
                        <div style={{ fontWeight: 700, fontSize: 12, color: '#0f172a', marginBottom: 2 }}>
                            {isOrderAlert ? alert.restaurant : alert.riderName}
                        </div>

                        {/* Note */}
                        <div style={{ fontSize: 11, color: '#475569', marginBottom: 3, lineHeight: 1.4 }}>
                            {alert.note}
                        </div>

                        {/* Sub-info */}
                        {isOrderAlert ? (
                            <div style={{ fontSize: 10, color: '#64748b', display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                <span>📋 #{alert.orderLabel}</span>
                                <span>👤 {alert.customer}</span>
                            </div>
                        ) : (
                            <div style={{ fontSize: 10, color: '#64748b' }}>
                                📍 {alert.label}
                            </div>
                        )}
                    </div>

                    {/* Delay/stationary timer */}
                    <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <div style={{
                            background: isHigh ? '#dc2626' : cfg.badge,
                            color: '#fff', borderRadius: 20,
                            padding: '3px 8px', fontSize: 11, fontWeight: 800,
                            fontFamily: "'DM Mono', monospace",
                            whiteSpace: 'nowrap',
                        }}>
                            ⏱ {fmtMs(timeMs)}
                        </div>
                        <div style={{ fontSize: 9, color: '#94a3b8' }}>{timeLabel}</div>
                    </div>
                </div>

                {/* Footer hint */}
                <div style={{ padding: '2px 10px 6px', fontSize: 9, color: '#94a3b8' }}>
                    {isOrderAlert
                        ? `Order · ${alert.restaurant}`
                        : 'Tap to locate on map →'}
                </div>
            </div>
        );
    };

    return (
        <>
            {/* Order delays section */}
            {orderAlerts.length > 0 && (
                <>
                    <div style={{
                        padding: '8px 12px 5px',
                        fontSize: 10, fontWeight: 800, letterSpacing: '0.06em',
                        textTransform: 'uppercase', color: '#94a3b8',
                        borderBottom: '1px solid #f1f5f9',
                    }}>
                        🧾 Order Delays ({orderAlerts.length})
                    </div>
                    {orderAlerts.map(renderAlert)}
                </>
            )}

            {/* Rider issues section */}
            {riderAlerts.length > 0 && (
                <>
                    <div style={{
                        padding: '8px 12px 5px',
                        marginTop: orderAlerts.length > 0 ? 4 : 0,
                        fontSize: 10, fontWeight: 800, letterSpacing: '0.06em',
                        textTransform: 'uppercase', color: '#94a3b8',
                        borderBottom: '1px solid #f1f5f9',
                    }}>
                        🛵 Rider Issues ({riderAlerts.length})
                    </div>
                    {riderAlerts.map(renderAlert)}
                </>
            )}
        </>
    );
};

const statusMap = {
    1: { label: "New",        cls: "order-status--pending"   },
    2: { label: "Accepted",   cls: "order-status--assigned"  },
    3: { label: "Preparing",  cls: "order-status--pickedup"  },
    4: { label: "On the Way", cls: "order-status--assigned"  },
    5: { label: "Delivered",  cls: "order-status--completed" },
    6: { label: "Cancelled",  cls: "order-status--cancelled" },
};

const StatusBadge = ({ status }) => {
    const cfg = statusMap[status] || { label: `Status ${status}`, cls: "order-status--pending" };
    return (
        <div className={`order-status ${cfg.cls}`} style={{ marginBottom: 0, padding: "5px 10px" }}>
            <span className="order-status__label" style={{ fontSize: 11 }}>
                <span className="order-status__dot" />
                {cfg.label}
            </span>
        </div>
    );
};

const RiderPopupContent = ({ point, color, availResult }) => {
    const detail = point?.detail || {};
    const name   = point?.name || detail?.name || "Rider";

    const caseLabel = availResult?.case === 'case1' ? 'Case 1 — Free & nearby'
        : availResult?.case === 'case2' || availResult?.case === 'case2-gps' ? 'Case 2 — Drop-off nearby'
            : null;

    const caseBg = availResult?.case === 'case1' ? '#dcfce7'
        : availResult?.case?.startsWith('case2') ? '#dbeafe' : null;

    const caseColor = availResult?.case === 'case1' ? '#15803d'
        : availResult?.case?.startsWith('case2') ? '#1d4ed8' : null;

    return (
        <div style={{ fontFamily: "'Inter', sans-serif", padding: "10px 14px", minWidth: 170 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
                <div style={{
                    width: 30, height: 30, borderRadius: "50%",
                    background: color,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 14, flexShrink: 0,
                }}>🛵</div>
                <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a" }}>{name}</div>
            </div>

            {caseLabel && (
                <div style={{ background: caseBg, color: caseColor, borderRadius: 6, padding: '4px 8px', fontSize: 11, fontWeight: 600, marginBottom: 6 }}>
                    {caseLabel}
                    {availResult?.dist && ` · ${availResult.dist} km`}
                </div>
            )}

            <div style={{
                display: "flex", alignItems: "center", gap: 6,
                background: "#eef2ff", borderRadius: 8, padding: "6px 10px",
            }}>
                <span style={{ fontSize: 11, color: "#6366f1", fontWeight: 600 }}>Pending orders</span>
                <span style={{
                    marginLeft: "auto",
                    background: "#6366f1", color: "#fff",
                    borderRadius: 20, padding: "1px 8px",
                    fontSize: 12, fontWeight: 800,
                    fontFamily: "'DM Mono', monospace",
                }}>{point?.non_complete_orders ?? 0}</span>
            </div>
        </div>
    );
};

const OrderPopupContent = ({ order }) => (
    <div style={{ fontFamily: "'Inter', sans-serif" }}>
        <div style={{
            display: "flex", alignItems: "center", gap: 10,
            padding: "11px 14px 10px",
            borderBottom: "3px solid #6366f1",
            background: "linear-gradient(135deg, #eef2ff 0%, #ffffff 100%)",
        }}>
            <div style={{
                width: 36, height: 36, borderRadius: "50%",
                background: "#6366f1",
                display: "flex", alignItems: "center", justifyContent: "center",
                fontSize: 16, flexShrink: 0,
                boxShadow: "0 2px 8px #6366f155",
            }}>📦</div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a" }}>
                    {order.restaurant || "Restaurant"}
                </div>
                <div style={{ fontSize: 10, color: "#6366f1", fontFamily: "'DM Mono', monospace", marginTop: 2 }}>
                    #{order.id}
                </div>
            </div>
        </div>
        <div style={{ padding: "8px 14px 4px" }}>
            {order.name && (
                <div className="tm-popup-row">
                    <span className="tm-popup-row-icon">👤</span>
                    <span className="tm-popup-row-label">Customer </span>
                    <span className="tm-popup-row-value" style={{ fontWeight: 600 }}>{order.name}</span>
                </div>
            )}
            {order.address && (
                <div className="tm-popup-row">
                    <span className="tm-popup-row-icon">📍</span>
                    <span className="tm-popup-row-label">To </span>
                    <span className="tm-popup-row-value" style={{ fontSize: 11, lineHeight: 1.4 }}>{order.address}</span>
                </div>
            )}
        </div>
        <div style={{ padding: "4px 14px 8px", fontSize: 11, color: '#6366f1', fontWeight: 600 }}>
            Click to see available riders
        </div>
        <div style={{ padding: "0 14px 10px" }}>
            <StatusBadge status={order.status} />
        </div>
    </div>
);

function HoverMarker({ position, icon, children, onClick }) {
    const markerRef = useRef(null);
    return (
        <Marker
            position={position}
            icon={icon}
            ref={markerRef}
            eventHandlers={{
                mouseover: () => markerRef.current?.openPopup(),
                mouseout:  () => markerRef.current?.closePopup(),
                click:     (e) => {
                    L.DomEvent.stopPropagation(e);
                    onClick?.();
                    markerRef.current?.openPopup();
                },
            }}
        >
            <Popup autoPan={false} keepInView={false} closeButton={false}>
                {children}
            </Popup>
        </Marker>
    );
}

const ElapsedTimer = ({ createdAt }) => {
    const [elapsed, setElapsed] = useState('');

    useEffect(() => {
        const calc = () => {
            if (!createdAt) return;
            const diffMs = Date.now() - new Date(createdAt).getTime();
            const totalSec = Math.floor(diffMs / 1000);
            const h = Math.floor(totalSec / 3600);
            const m = Math.floor((totalSec % 3600) / 60);
            const s = totalSec % 60;
            if (h > 0) setElapsed(`${h}h ${m}m`);
            else if (m > 0) setElapsed(`${m}m ${s}s`);
            else setElapsed(`${s}s`);
        };
        calc();
        const id = setInterval(calc, 1000);
        return () => clearInterval(id);
    }, [createdAt]);

    if (!elapsed) return null;

    const isLate = (Date.now() - new Date(createdAt).getTime()) > 30 * 60 * 1000;

    return (
        <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 3,
            marginTop: 3, fontSize: 10, fontWeight: 700,
            fontFamily: "'DM Mono', monospace",
            color: isLate ? '#dc2626' : '#6366f1',
        }}>
            ⏱ {elapsed}
        </span>
    );
};


const fmtMs = (ms) => {
    const m = Math.floor(ms / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
};

const WATCH_CONFIG = {
    prep_overdue: {
        icon: '⏰', label: 'Overdue Prep',
        bg: '#fff1f2', border: '#fda4af', text: '#9f1239', badge: '#f43f5e',
    },
    wait_dropoff: {
        icon: '🏠', label: 'At Drop-off',
        bg: '#fef2f2', border: '#fecaca', text: '#991b1b', badge: '#ef4444',
    },
    wait_restaurant: {
        icon: '🍽️', label: 'At Restaurant',
        bg: '#fef9c3', border: '#fde68a', text: '#92400e', badge: '#f59e0b',
    },
    late_order: {
        icon: '⏱️', label: 'Late Order',
        bg: '#fff1f2', border: '#fda4af', text: '#9f1239', badge: '#dc2626',
    },
    prep_delayed: {
        icon: '🕐', label: 'Prep Delayed',
        bg: '#fff7ed', border: '#fed7aa', text: '#7c2d12', badge: '#f97316',
    },
    new_delayed: {
        icon: '🆕', label: 'New — No Accept',
        bg: '#faf5ff', border: '#e9d5ff', text: '#581c87', badge: '#a855f7',
    },
    stuck_transit: {
        icon: '🚦', label: 'Stuck in Transit',
        bg: '#f0f9ff', border: '#bae6fd', text: '#0c4a6e', badge: '#0ea5e9',
    },
};


// ── Main component ────────────────────────────────────────────────────────────
const TrackingMap = ({ points = [], orderPoints = [],  radiusKm = 3.0  }) => {
    const [flyTarget, setFlyTarget]       = useState(null);
    const [open, setOpen]         = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [sidebarTab, setSidebarTab]     = useState('riders');
    const [showBoth, setShowBoth]         = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [selectedRiderId, setSelectedRiderId] = useState(null);


    const [assigningRiderId, setAssigningRiderId] = useState(null);
    const [assignedMap, setAssignedMap] = useState({}); // { orderId: riderId }



    const showRiders = showBoth || sidebarTab === 'riders';
    const showOrders = showBoth || sidebarTab === 'orders';

    const validPoints = useMemo(() =>
            points.filter(
                (p) => p?.detail?.delivery_lat != null && p?.detail?.delivery_long != null
            ),
        [points]);

    const formattedOrders = useMemo(() =>
            orderPoints
                .filter((o) => [1, 2].includes(Number(o.orderstatus_id)))
                .map((o) => {
                    try {
                        const loc = typeof o.location === "string" ? JSON.parse(o.location) : o.location;

                        return {
                            id:         o.order_id,
                            name:       o.customer_name,
                            lat:        parseFloat(o?.restaurant_latitude),
                            lng:        parseFloat(o?.restaurant_longitude),
                            address:    loc?.address,
                            status:     Number(o.orderstatus_id),
                            restaurant: o.restaurant_name,
                            createdAt:  o.created_at,
                            customerId: o.customer_id
                        };
                    } catch {
                        return null;
                    }
                })
                .filter((o) => o && !isNaN(o.lat) && !isNaN(o.lng)),
        [orderPoints]
    );


    const handleAssign = useCallback(async (orderId, userId, customerId) => {
        setAssigningRiderId(userId);
        try {
            await assignDeliveryFromAdmin(orderId, userId, customerId);
            setAssignedMap(prev => ({ ...prev, [orderId]: userId }));
        } catch (e) {
            console.error('Assign failed', e);
        } finally {
            setAssigningRiderId(null);
        }
    }, []);

    // ── Compute which riders are highlighted for the selected order ──────────
    const riderAvailability = useMemo(() => {
        if (!selectedOrderId) return {};
        const order = formattedOrders.find(o => o.id === selectedOrderId);
        if (!order) return {};

        const result = {};
        validPoints.forEach((rider) => {
            const av = evaluateRiderForOrder(rider, order, orderPoints, radiusKm);
            if (av) result[rider.user_id] = av;
        });
        return result;
    }, [selectedOrderId, formattedOrders, validPoints, orderPoints]);

    // Riders that are highlighted (available for selected order)
    const highlightedRiderIds = useMemo(() =>
            Object.entries(riderAvailability)
                .filter(([, av]) => av.isAvailable)
                .map(([id]) => Number(id)),
        [riderAvailability]
    );


    const riderLineData = useMemo(() => {
        if (!selectedRiderId) return null;
        const rider = validPoints.find(p => p.user_id === selectedRiderId);
        if (!rider) return null;

        const riderLat = parseFloat(rider.detail.delivery_lat);
        const riderLng = parseFloat(rider.detail.delivery_long);

        // Strict match with type coercion fix
        const activeOrder = orderPoints.find(o =>
            (o.delivery_guy_id === rider.user_id || o.delivery_guy_id === rider.id) &&
            [3, 4].includes(o.orderstatus_id)
        );

        if (!activeOrder) return null;

        let dropLat, dropLng, dropLabel, dropType;

        if (activeOrder.orderstatus_id === 4) {
            try {
                const loc = typeof activeOrder.location === 'string'
                    ? JSON.parse(activeOrder.location)
                    : activeOrder.location;
                dropLat = parseFloat(loc?.lat ?? loc?.latitude);
                dropLng = parseFloat(loc?.lng ?? loc?.longitude);
                dropLabel = activeOrder.customer_name || 'Customer';
                dropType = 'customer';

                console.log("loc: ", loc)

            } catch (_) { return null; }
        } else {
            dropLat = parseFloat(activeOrder.restaurant_latitude);
            dropLng = parseFloat(activeOrder.restaurant_longitude);
            dropLabel = activeOrder.restaurant_name || 'Restaurant';
            dropType = 'restaurant';
        }

        if (isNaN(dropLat) || isNaN(dropLng)) return null;

        const response =  {
            riderPos: [riderLat, riderLng],
            dropPos: [dropLat, dropLng],
            dropLabel,
            dropType,
            riderName: rider.name || rider.detail?.name,
        };

        return response;
    }, [selectedRiderId, validPoints, orderPoints]);

    const orderRiderLines = useMemo(() => {
        if (!selectedOrderId || sidebarTab !== 'orders') return [];
        const order = formattedOrders.find(o => o.id === selectedOrderId);
        if (!order) return [];

        return highlightedRiderIds
            .map(riderId => {
                const rider = validPoints.find(p => p.user_id === riderId);
                if (!rider) return null;
                const av = riderAvailability[riderId];

                const riderPos = [
                    parseFloat(rider.detail.delivery_lat),
                    parseFloat(rider.detail.delivery_long),
                ];

                if (av?.case === 'case1') {
                    // Free rider — line goes to the restaurant
                    return {
                        riderId,
                        riderPos,
                        destPos: [order.lat, order.lng],
                        case: 'case1',
                    };
                }

                if (av?.case === 'case2' || av?.case === 'case2-gps') {
                    const pickedUpOrders = orderPoints.filter(o =>
                        o.orderstatus_id === 4
                    );

                    // console.log("pickedUpOrders: ", pickedUpOrders)

                    const pickedUpOrder = pickedUpOrders?.find(order => {
                        const orderRiderId = Number(order.delivery_guy_id);

                        // console.log({
                        //     order_id: order.order_id,
                        //     orderRiderId,
                        //     riderId,
                        //     matched: orderRiderId === riderId,
                        // });

                        return orderRiderId === riderId;
                    });

                    // console.log("rider: ", rider.user_id)
                    // console.log("pikupOrder: ", pickedUpOrders)

                    if (pickedUpOrder) {
                        try {
                            const loc = typeof pickedUpOrder.location === 'string'
                                ? JSON.parse(pickedUpOrder.location)
                                : pickedUpOrder.location;
                            const custLat = parseFloat(loc?.lat ?? loc?.latitude);
                            const custLng = parseFloat(loc?.lng ?? loc?.longitude);
                            if (!isNaN(custLat) && !isNaN(custLng)) {
                                return {
                                    riderId,
                                    riderPos,
                                    destPos: [custLat, custLng],
                                    case: 'case2',
                                    dropLabel: pickedUpOrder.customer_name || 'Customer',
                                };
                            }
                        } catch { /* fall through */ }
                    }

                    // case2-gps or no customer coords — rider is preparing, line to restaurant
                    return {
                        riderId,
                        riderPos,
                        destPos: [order.lat, order.lng],
                        case: 'case2-gps',
                        dropLabel: 'Restaurant (preparing)',
                    };
                }

                return null;
            })
            .filter(Boolean);
    }, [selectedOrderId, sidebarTab, formattedOrders, highlightedRiderIds, validPoints, riderAvailability, orderPoints]);

    // Parse '2026-06-12 13:50:59' → ms since epoch
    const parseOrderTime = (str) => {
        if (!str) return null;
        const ms = new Date(str.replace(' ', 'T')).getTime();
        return isNaN(ms) ? null : ms;
    };

    // Parse live.ready_at (unix seconds string) → ms since epoch
    const parseReadyAt = (val) => {
        if (!val) return null;
        const n = Number(val);
        if (isNaN(n) || n === 0) return null;
        // Unix seconds → ms  (ready_at values are ~1.78B = year 2026, safe to treat as seconds)
        return n * 1000;
    };


    const riderPositionHistory = useRef({});

    useEffect(() => {
        const now = Date.now();
        validPoints.forEach((rider) => {
            const uid = rider.user_id;
            const lat = parseFloat(rider.detail?.delivery_lat);
            const lng = parseFloat(rider.detail?.delivery_long);
            if (isNaN(lat) || isNaN(lng)) return;

            const prev = riderPositionHistory.current[uid];
            if (!prev) {
                riderPositionHistory.current[uid] = { lat, lng, recordedAt: now };
                return;
            }

            const moved = haversineKm(prev.lat, prev.lng, lat, lng) > 0.05; // >50m = moved
            if (moved) {
                // Rider moved — reset their stationary clock
                riderPositionHistory.current[uid] = { lat, lng, recordedAt: now };
            }
            // If not moved, keep old recordedAt — stationaryMs keeps growing
        });
    }, [validPoints]);


    // ── Watchout thresholds ───────────────────────────────────────────────────────
    const STUCK_TRANSIT_MS   = 3 * 60 * 1000;  // 3 min — not near any known location
    const WAIT_RESTAURANT_MS = 3 * 60 * 1000;  // 3 min — at restaurant, not moving
    const WAIT_DROPOFF_MS    = 5 * 60 * 1000;  // 5 min — at customer, not moving
    const NEAR_KM            = 0.15;           // 150m radius = "at location"
    const NEW_ORDER_DELAY_MS = 5 * 60 * 1000; // 5 min — store hasn't accepted
    const LATE_ORDER_MS      = 30 * 60 * 1000; // 30 min — order considered late
    const PREP_DEFAULT_MS    = 10 * 60 * 1000; // 10 min default prep (no live object)
    const PREP_LIVE_MS       = 15 * 60 * 1000; // 15 min fallback (live exists, no ready_at)

    const PRIORITY = {
        late_order:      0,  // order is late overall — most urgent order issue
        prep_overdue:    1,  // past ready_at time
        wait_dropoff:    2,  // rider stuck at customer
        wait_restaurant: 3,  // rider stuck at restaurant
        prep_delayed:    4,  // preparing but no ready_at, time exceeded
        new_delayed:     5,  // new order not accepted by store
        stuck_transit:   6,  // rider not moving in unknown location
    };

    const watchoutAlerts = useMemo(() => {
        const now    = Date.now();
        const nowSec = now / 1000;
        const alerts = [];

        let late = 0;

        // ── ORDER-BASED ALERTS ────────────────────────────────────────────────────
        orderPoints.forEach((o) => {
            const statusId  = Number(o.orderstatus_id);
            const createdMs = parseOrderTime(o.created_at);
            const ageMs     = createdMs ? now - createdMs : null;

            const orderMeta = {
                orderId:    o.order_id,
                orderLabel: o.unique_order_id?.slice(10) || String(o.order_id),
                restaurant: o.restaurant_name || 'Restaurant',
                customer:   o.customer_name   || 'Customer',
            };

            const isReadyForPickup = o.live?.status === 'ready_for_pickup';
            const readyAtMs        = parseReadyAt(o.live?.ready_at);

            // ── Alert 1: Late order — placed > 30 min ago (status 1/2/3/4) ────
            // Base: order is late. Sub-priorities layered on top:
            //   Sub-A: prep time done but food not marked ready yet
            //   Sub-B: food ready + assigned (status 3) but rider not at restaurant
            // Both can coexist. Either alone = high severity.
            if (ageMs !== null && ageMs >= LATE_ORDER_MS && [1, 2, 3, 4].includes(statusId)) {
                late++;
                // Sub-priority A: is prep time done but not ready_for_pickup?
                let prepDone = false;
                if (!isReadyForPickup) {
                    prepDone = readyAtMs ? now > readyAtMs : ageMs >= PREP_DEFAULT_MS;
                }

                // Sub-priority B: status 3, food ready, assigned rider not at restaurant
                let riderNotThere = false;
                let riderName     = o.delivery_guy_name || null;
                if (statusId === 3 && isReadyForPickup && o.delivery_guy_id) {
                    const assignedRider = validPoints.find(
                        p => p.user_id === Number(o.delivery_guy_id) || p.user_id === o.delivery_guy_id
                    );
                    if (assignedRider) {
                        const rLat   = parseFloat(o.restaurant_latitude);
                        const rLng   = parseFloat(o.restaurant_longitude);
                        const ridLat = parseFloat(assignedRider.detail?.delivery_lat);
                        const ridLng = parseFloat(assignedRider.detail?.delivery_long);
                        if (!isNaN(rLat) && !isNaN(ridLat)) {
                            riderNotThere = haversineKm(ridLat, ridLng, rLat, rLng) > NEAR_KM;
                        }
                    } else {
                        riderNotThere = true; // assigned but not in active riders list
                    }
                }

                // Both subs present = 0 (worst), prep only = 1, rider only = 2, plain = 3
                const subPriority = (prepDone && riderNotThere) ? 0
                    : prepDone                                   ? 1
                        : riderNotThere                              ? 2
                            :                                              3;

                const hasSub   = prepDone || riderNotThere;
                const severity = hasSub || ageMs >= 45 * 60 * 1000 ? 'high' : 'medium';

                alerts.push({
                    type:         'late_order',
                    severity,
                    category:     'order',
                    priority:     PRIORITY.late_order,
                    subPriority,
                    delayMs:      ageMs,
                    prepDone,
                    riderNotThere,
                    riderName,
                    isReadyForPickup,
                    ...orderMeta,
                    note: `Placed ${Math.floor(ageMs / 60000)} min ago`,
                });
            }

            // ── Alert 2: Prep overdue (ready_at passed, no ready_for_pickup yet) ──
            if (statusId === 2 && !isReadyForPickup) {
                const hasLive   = !!o.live;

                if (readyAtMs) {
                    // We have an explicit ready_at — alert if now is past it
                    const overdueMs = now - readyAtMs;
                    if (overdueMs > 0) {
                        alerts.push({
                            type:      'prep_overdue',
                            severity:  overdueMs >= 5 * 60 * 1000 ? 'high' : 'medium',
                            category:  'order',
                            priority:  PRIORITY.prep_overdue,
                            delayMs:   overdueMs,
                            ...orderMeta,
                            note:      'Past estimated ready time',
                        });
                    }
                } else if (ageMs !== null) {
                    // No ready_at — use time-based fallback
                    const threshold = hasLive ? PREP_LIVE_MS : PREP_DEFAULT_MS;
                    if (ageMs >= threshold) {
                        alerts.push({
                            type:      'prep_delayed',
                            severity:  ageMs >= threshold + 5 * 60 * 1000 ? 'high' : 'medium',
                            category:  'order',
                            priority:  PRIORITY.prep_delayed,
                            delayMs:   ageMs,
                            ...orderMeta,
                            note:      hasLive
                                ? 'Preparing >15 min — restaurant slow?'
                                : 'Preparing >10 min — no update from restaurant',
                        });
                    }
                }
            }

            // ── 2. New order not accepted by store after 5 min ───────────────────
            if (statusId === 1 && ageMs !== null && ageMs >= NEW_ORDER_DELAY_MS) {
                alerts.push({
                    type:      'new_delayed',
                    severity:  ageMs >= 10 * 60 * 1000 ? 'high' : 'medium',
                    category:  'order',
                    priority:  PRIORITY.new_delayed,
                    delayMs:   ageMs,
                    ...orderMeta,
                    note:      'Store hasn\'t accepted — needs attention',
                });
            }
        });


        console.log(late)

        // ── RIDER-BASED ALERTS ────────────────────────────────────────────────────
        validPoints.forEach((rider) => {
            const uid        = rider.user_id;
            const name       = rider.name || rider.detail?.name || 'Rider';
            const lat        = parseFloat(rider.detail?.delivery_lat);
            const lng        = parseFloat(rider.detail?.delivery_long);
            if (isNaN(lat) || isNaN(lng)) return;

            const hist         = riderPositionHistory.current[uid];
            const stationaryMs = hist ? now - hist.recordedAt : 0;
            const nonComplete  = Number(rider.non_complete_orders ?? 0);

            const riderMeta = {
                riderId:    uid,
                riderName:  name,
                riderPhoto: rider.detail?.photo,
                lat, lng,
                stationaryMs,
            };



            // Orders belonging to this rider
            const riderOrders = orderPoints.filter(o =>
                Number(o.delivery_guy_id) === uid || o.delivery_guy_id === rider.id
            );


            // ── 3. Waiting at restaurant ─────────────────────────────────────────
            const atRestaurantOrder = riderOrders.find(o => {
                if (![3, 4].includes(Number(o.orderstatus_id))) return false;
                const rLat = parseFloat(o.restaurant_latitude);
                const rLng = parseFloat(o.restaurant_longitude);
                return !isNaN(rLat) && haversineKm(lat, lng, rLat, rLng) <= NEAR_KM;
            });

            if (atRestaurantOrder && stationaryMs >= WAIT_RESTAURANT_MS) {
                alerts.push({
                    type:     'wait_restaurant',
                    severity: stationaryMs >= 6 * 60 * 1000 ? 'high' : 'medium',
                    category: 'rider',
                    priority: PRIORITY.wait_restaurant,
                    orderId:  atRestaurantOrder.order_id,
                    label:    atRestaurantOrder.restaurant_name || 'Restaurant',
                    note:     'Waiting at restaurant — food not ready?',
                    ...riderMeta,
                });
                return; // one alert per rider, most specific first
            }

            // ── 4. Long wait at drop-off ─────────────────────────────────────────
            const atDropoffOrder = riderOrders.find(o => {
                if (Number(o.orderstatus_id) !== 4) return false;
                try {
                    const loc  = typeof o.location === 'string' ? JSON.parse(o.location) : o.location;
                    const cLat = parseFloat(loc?.lat ?? loc?.latitude);
                    const cLng = parseFloat(loc?.lng ?? loc?.longitude);
                    return !isNaN(cLat) && haversineKm(lat, lng, cLat, cLng) <= NEAR_KM;
                } catch { return false; }
            });

            if (atDropoffOrder && stationaryMs >= WAIT_DROPOFF_MS) {
                alerts.push({
                    type:     'wait_dropoff',
                    severity: stationaryMs >= 10 * 60 * 1000 ? 'high' : 'medium',
                    category: 'rider',
                    priority: PRIORITY.wait_dropoff,
                    orderId:  atDropoffOrder.order_id,
                    label:    atDropoffOrder.customer_name || 'Customer',
                    note:     'At drop-off — customer not answering?',
                    ...riderMeta,
                });
                return;
            }


            console.log("riderMeta: ", riderMeta, ", | Non completed orders: ", nonComplete, ",  | STUCK_TRANSIT_MS: ", STUCK_TRANSIT_MS)

            // ── 5. Stuck in transit ──────────────────────────────────────────────
            if (nonComplete > 0 && stationaryMs >= STUCK_TRANSIT_MS) {
                const nearKnown = riderOrders.some(o => {
                    const rLat = parseFloat(o.restaurant_latitude);
                    const rLng = parseFloat(o.restaurant_longitude);
                    if (!isNaN(rLat) && haversineKm(lat, lng, rLat, rLng) <= NEAR_KM) return true;
                    try {
                        const loc  = typeof o.location === 'string' ? JSON.parse(o.location) : o.location;
                        const cLat = parseFloat(loc?.lat ?? loc?.latitude);
                        const cLng = parseFloat(loc?.lng ?? loc?.longitude);
                        return !isNaN(cLat) && haversineKm(lat, lng, cLat, cLng) <= NEAR_KM;
                    } catch { return false; }
                });

                if (!nearKnown) {
                    alerts.push({
                        type:     'stuck_transit',
                        severity: stationaryMs >= 8 * 60 * 1000 ? 'high' : 'medium',
                        category: 'rider',
                        priority: PRIORITY.stuck_transit,
                        orderId:  null,
                        label:    `${nonComplete} pending order${nonComplete > 1 ? 's' : ''}`,
                        note:     'Not moving — may be stuck or stopped',
                        ...riderMeta,
                    });
                }
            }
        });

        // Sort: high severity first → priority → subPriority (if present) → longest delay/stationary
        return alerts.sort((a, b) => {
            if (a.severity !== b.severity) return a.severity === 'high' ? -1 : 1;
            if (a.priority !== b.priority) return a.priority - b.priority;
            if (a.subPriority !== undefined && b.subPriority !== undefined && a.subPriority !== b.subPriority) {
                return a.subPriority - b.subPriority;
            }
            const aTime = a.delayMs ?? a.stationaryMs ?? 0;
            const bTime = b.delayMs ?? b.stationaryMs ?? 0;
            return bTime - aTime;
        });
    }, [validPoints, orderPoints]); // eslint-disable-line react-hooks/exhaustive-deps


    const allBoundsPoints = [
        ...(showRiders ? validPoints.map((p) => [p.detail.delivery_lat, p.detail.delivery_long]) : []),
        ...(showOrders ? formattedOrders.map((o) => [o.lat, o.lng]) : []),
        ...(sidebarTab === 'orders' && selectedOrderId
            ? highlightedRiderIds
                .map(id => validPoints.find(p => p.user_id === id))
                .filter(Boolean)
                .map(p => [p.detail.delivery_lat, p.detail.delivery_long])
            : []),
    ];

    const handleLocate = useCallback((lng, lat) => {
        setFlyTarget({ lat, lng, _t: Date.now() });
    }, []);

    const handleOrderClick = useCallback((orderId) => {
        setSelectedOrderId(prev => prev === orderId ? null : orderId);
    }, []);

    const mapContent = useMemo(() => (
        <MapContainer
            center={[16.4346, 80.5662]}
            zoom={15}
            style={{ width: "100%", height: "100%" }}
            attributionControl={false}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; OpenStreetMap'
            />
            {allBoundsPoints.length > 0 && <FitBounds points={allBoundsPoints} />}
            {flyTarget && <FlyTo target={flyTarget} key={flyTarget._t} />}

            {/* Rider markers */}
            {showRiders && validPoints.map((p, idx) => {
                const av    = sidebarTab === 'orders' ? riderAvailability[p.user_id] : null;
                const isHL  = sidebarTab === 'orders' && highlightedRiderIds.includes(p.user_id);
                // const color = isHL
                //     ? (av?.case === 'case1' ? '#22c55e' : '#3b82f6')
                //     : getPendingColor(p?.non_complete_orders);

                const color = getPendingColor(p?.non_complete_orders);

                // If an order is selected, dim non-highlighted riders
                return (
                    <div key={`rider-wrap-${idx}`}>
                        <HoverMarker
                            position={[p.detail.delivery_lat, p.detail.delivery_long]}
                            icon={makeRiderIcon(p.detail.heading, color, isHL, av?.case)}
                        >
                            <RiderPopupContent point={p} color={color} availResult={isHL ? av : null} />
                        </HoverMarker>
                    </div>
                );
            })}

            {/* Order markers */}
            {showOrders && formattedOrders.map((o, idx) => {
                const isSelected = selectedOrderId === o.id;
                return (
                    <HoverMarker
                        key={`order-${idx}`}
                        position={[o.lat, o.lng]}
                        icon={makeOrderIcon(isSelected)}
                        onClick={() => handleOrderClick(o.id)}
                    >
                        <OrderPopupContent order={o} />
                    </HoverMarker>
                );
            })}

            {/* Available rider markers for selected order — orders tab only */}
            {sidebarTab === 'orders' && selectedOrderId && highlightedRiderIds.map((riderId) => {
                const p = validPoints.find(r => r.user_id === riderId);
                if (!p) return null;
                const av = riderAvailability[p.user_id];
                const color = getPendingColor(p?.non_complete_orders);
                return (
                    <HoverMarker
                        key={`avail-rider-${riderId}`}
                        position={[p.detail.delivery_lat, p.detail.delivery_long]}
                        icon={makeRiderIcon(p.detail.heading, color, true, av?.case)}
                    >
                        <RiderPopupContent point={p} color={color} availResult={av} />
                    </HoverMarker>
                );
            })}


            {/* Rider → drop-off line */}
            {riderLineData && (
                <>
                    <Polyline
                        positions={[riderLineData.riderPos, riderLineData.dropPos]}
                        pathOptions={{
                            color: riderLineData.dropType === 'customer' ? '#6366f1' : '#f59e0b',
                            weight: 3,
                            dashArray: '8 6',
                            opacity: 0.85,
                        }}
                    />
                    <CircleMarker
                        center={riderLineData.dropPos}
                        radius={10}
                        pathOptions={{
                            color: riderLineData.dropType === 'customer' ? '#6366f1' : '#f59e0b',
                            fillColor: riderLineData.dropType === 'customer' ? '#eef2ff' : '#fefce8',
                            fillOpacity: 1,
                            weight: 2.5,
                        }}
                    >
                        <Popup closeButton={false} autoPan={false}>
                            <div style={{ fontFamily: 'Inter, sans-serif', padding: '6px 10px', fontSize: 12 }}>
                                <div style={{ fontWeight: 700, color: '#0f172a' }}>
                                    {riderLineData.dropType === 'customer' ? '🏠' : '🍽️'} {riderLineData.dropLabel}
                                </div>
                                <div style={{ fontSize: 10, color: '#64748b', marginTop: 2 }}>
                                    {riderLineData.dropType === 'customer' ? 'Drop-off destination' : 'Pickup restaurant'}
                                </div>
                            </div>
                        </Popup>
                    </CircleMarker>
                </>
            )}

            {/* Available rider → restaurant lines (orders tab) */}
            {orderRiderLines.map((line) => (
                <React.Fragment key={`order-line-${line.riderId}`}>
                    <Polyline
                        positions={[line.riderPos, line.destPos]}
                        pathOptions={{
                            color: line.case === 'case1' ? '#22c55e' : '#3b82f6',
                            weight: 2.5,
                            dashArray: '6 5',
                            opacity: 0.8,
                        }}
                    />
                    <CircleMarker
                        center={line.destPos}
                        radius={7}
                        pathOptions={{
                            color: line.case === 'case1' ? '#22c55e' : '#3b82f6',
                            fillColor: line.case === 'case1' ? '#dcfce7' : '#dbeafe',
                            fillOpacity: 1,
                            weight: 2,
                        }}
                    >
                        <Popup closeButton={false} autoPan={false}>
                            <div style={{ fontFamily: 'Inter, sans-serif', padding: '6px 10px', fontSize: 12 }}>
                                <div style={{ fontWeight: 700, color: '#0f172a' }}>
                                    {line.case === 'case1' ? '🍽️ Restaurant' : `🏠 ${line.dropLabel}`}
                                </div>
                                <div style={{ fontSize: 10, color: '#64748b', marginTop: 2 }}>
                                    {line.case === 'case1' ? 'Rider heading here' : 'Current drop-off'}
                                </div>
                            </div>
                        </Popup>
                    </CircleMarker>
                </React.Fragment>
            ))}
        </MapContainer>
    ), [validPoints, formattedOrders, orderRiderLines, riderLineData, flyTarget, allBoundsPoints, showRiders, showOrders, sidebarTab, selectedOrderId, highlightedRiderIds, riderAvailability]);

    // Sidebar available riders count for selected order
    const availableForSelected = highlightedRiderIds.length;


    const BUBBLE_KEY = 'eagleview_bubble_pos';
    const defaultPos = { right: 24, bottom: 24 };

    const [bubblePos, setBubblePos] = useState(() => {
        try {
            const saved = localStorage.getItem(BUBBLE_KEY);
            return saved ? JSON.parse(saved) : defaultPos;
        } catch { return defaultPos; }
    });
    const draggingRef = useRef(false);
    const dragOffset  = useRef({ x: 0, y: 0 });

    const onBubbleMouseDown = useCallback((e) => {
        e.preventDefault();
        draggingRef.current = false;
        const startX = e.clientX;
        const startY = e.clientY;
        const startLeft = e.currentTarget.getBoundingClientRect().left;
        const startTop  = e.currentTarget.getBoundingClientRect().top;
        dragOffset.current = { startX, startY, startLeft, startTop };

        const onMove = (me) => {
            const dx = me.clientX - startX;
            const dy = me.clientY - startY;
            if (Math.abs(dx) > 3 || Math.abs(dy) > 3) draggingRef.current = true;
            if (!draggingRef.current) return;

            const newLeft = Math.max(0, Math.min(window.innerWidth - 110, startLeft + dx));
            const newTop  = Math.max(0, Math.min(window.innerHeight - 80, startTop + dy));
            const newPos  = { left: newLeft, top: newTop, right: 'auto', bottom: 'auto' };
            setBubblePos(newPos);
        };

        const onUp = () => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);
            setBubblePos(prev => {
                try { localStorage.setItem(BUBBLE_KEY, JSON.stringify(prev)); } catch {}
                return prev;
            });
        };

        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onUp);
    }, []);

    return (
        <>
            {/* ── Floating bubble ── */}
            <div
                className="map-float-bubble"
                style={{ ...bubblePos, cursor: 'grab', userSelect: 'none' }}
                onMouseDown={onBubbleMouseDown}
                onClick={() => { if (!draggingRef.current) setOpen(true); }}
            >
                <div className="map-float-preview" style={{ pointerEvents: 'none' }}>
                    <MapContainer
                        center={[16.4346, 80.5662]}
                        zoom={12}
                        style={{ width: '100%', height: '100%' }}
                        zoomControl={false}
                        dragging={false}
                        scrollWheelZoom={false}
                        doubleClickZoom={false}
                        touchZoom={false}
                        attributionControl={false}
                    >
                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                        {validPoints.map((p, idx) => (
                            <Marker
                                key={idx}
                                position={[p.detail.delivery_lat, p.detail.delivery_long]}
                                icon={makeRiderIcon(p.detail.heading, getPendingColor(p?.non_complete_orders))}
                            />
                        ))}
                    </MapContainer>
                </div>
                <div className="map-float-label">
                    🗺️ Eagle View
                    <span className="map-float-count">{validPoints.length}</span>
                </div>
            </div>

            {/* ── Full modal ── */}
            {open && (
                <div className="map-modal-overlay" onClick={() => {
                    setOpen(false);
                    setExpanded(false);
                }}>
                    <div
                        className="map-modal-inner"
                        onClick={(e) => e.stopPropagation()}
                        style={expanded ? {
                            width: '100vw',
                            height: '100vh',
                            maxWidth: '100vw',
                            maxHeight: '100vh',
                            borderRadius: 0,
                            top: 0,
                            left: 0,
                            margin: 0,
                            position: 'fixed',
                            inset: 0,
                        } : undefined}
                    >
                        {/* Close button */}
                        <button
                            className="map-modal-close"
                            onClick={() => {
                                setOpen(false);
                                setExpanded(false);
                            }}
                            title="Minimize"
                            style={{right: expanded ? 56 : undefined}}
                        >
                            ✕
                        </button>

                        {/* Expand / collapse toggle button */}
                        <button
                            className="map-modal-close"
                            onClick={() => setExpanded(e => !e)}
                            title={expanded ? 'Exit full screen' : 'Full screen'}
                            style={{right: 12}}
                        >
                            {expanded
                                ? /* collapse icon — two inward arrows */
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                     stroke="currentColor" strokeWidth="2.2"
                                     strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="4 14 10 14 10 20"/>
                                    <polyline points="20 10 14 10 14 4"/>
                                    <line x1="10" y1="14" x2="3" y2="21"/>
                                    <line x1="21" y1="3" x2="14" y2="10"/>
                                </svg>
                                : /* expand icon — two outward arrows */
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                                     stroke="currentColor" strokeWidth="2.2"
                                     strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="15 3 21 3 21 9"/>
                                    <polyline points="9 21 3 21 3 15"/>
                                    <line x1="21" y1="3" x2="14" y2="10"/>
                                    <line x1="3" y1="21" x2="10" y2="14"/>
                                </svg>
                            }
                        </button>

                        <div className="map-dashboard-wrapper" style={{height: '100%', margin: 0, borderRadius: 0}}>
                            <div className="map-container-main">{mapContent}</div>

                            <div className="map-sidebar">
                                <div className="section-header" style={{
                                    padding: '16px 20px',
                                    background: '#fff',
                                    borderBottom: '1px solid #e2e8f0',
                                    justifyContent: 'space-between'
                                }}>
                                    <p className="eagleview-title">Eagle View</p>
                                    <span className="eagleview-count">{validPoints.length}</span>
                                </div>

                                {/* Selected order info strip */}
                                {selectedOrderId && sidebarTab === 'orders' && (
                                    <div style={{
                                        padding: '10px 16px',
                                        background: '#eef2ff',
                                        borderBottom: '1px solid #c7d2fe',
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                    }}>
                                        <div>
                                            <div style={{fontSize: 11, fontWeight: 700, color: '#4338ca'}}>
                                                {formattedOrders.find(o => o.id === selectedOrderId)?.restaurant}
                                            </div>
                                            <div style={{fontSize: 10, color: '#6366f1', marginTop: 1}}>
                                                {availableForSelected} rider{availableForSelected !== 1 ? 's' : ''} available
                                                nearby
                                            </div>
                                        </div>
                                        <button
                                            onClick={() => setSelectedOrderId(null)}
                                            style={{
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                fontSize: 16,
                                                color: '#6366f1',
                                                lineHeight: 1
                                            }}
                                            title="Clear selection"
                                        >×
                                        </button>
                                    </div>
                                )}

                                {/* Legend strip when order selected */}
                                {selectedOrderId && sidebarTab === 'orders' && (
                                    <div style={{
                                        padding: '6px 16px',
                                        background: '#f8fafc',
                                        borderBottom: '1px solid #e2e8f0',
                                        display: 'flex',
                                        gap: 12
                                    }}>
                                        <span style={{
                                            fontSize: 10,
                                            color: '#64748b',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4
                                        }}>
                                            <span style={{
                                                width: 8,
                                                height: 8,
                                                borderRadius: '50%',
                                                background: '#22c55e',
                                                display: 'inline-block'
                                            }}/>
                                            Case 1: free & nearby
                                        </span>
                                        <span style={{
                                            fontSize: 10,
                                            color: '#64748b',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 4
                                        }}>
                                            <span style={{
                                                width: 8,
                                                height: 8,
                                                borderRadius: '50%',
                                                background: '#3b82f6',
                                                display: 'inline-block'
                                            }}/>
                                            Case 2: drop-off nearby
                                        </span>
                                    </div>
                                )}

                                {/* Tabs */}
                                <div style={{display: 'flex', borderBottom: '1px solid #e2e8f0', background: '#fff'}}>
                                    {['riders', 'orders', 'watch'].map((t) => (
                                        <button
                                            key={t}
                                            onClick={() => {
                                                if (sidebarTab === t && !showBoth) setShowBoth(true);
                                                else {
                                                    setSidebarTab(t);
                                                    setShowBoth(false);
                                                }
                                            }}
                                            style={{
                                                flex: 1, padding: '9px 0', fontSize: 12, fontWeight: 700,
                                                fontFamily: 'Inter, sans-serif', letterSpacing: '0.04em',
                                                textTransform: 'uppercase', border: 'none',
                                                borderBottom: sidebarTab === t ? '2px solid #6366f1' : '2px solid transparent',
                                                background: 'none',
                                                color: sidebarTab === t ? '#6366f1' : '#94a3b8',
                                                cursor: 'pointer', transition: 'color 0.15s',
                                            }}
                                        >
                                            {t === 'riders'
                                                ? `🛵 Riders (${validPoints.length})`
                                                : t === 'orders'
                                                    ? `📦 Orders (${formattedOrders.length})`
                                                    : (
                                                        <span style={{
                                                            display: 'inline-flex',
                                                            alignItems: 'center',
                                                            gap: 4
                                                        }}>
                                                            ⚠️ Watch
                                                            {watchoutAlerts.length > 0 && (
                                                                <span style={{
                                                                    background: watchoutAlerts.some(a => a.severity === 'high') ? '#dc2626' : '#f59e0b',
                                                                    color: '#fff',
                                                                    borderRadius: 20,
                                                                    padding: '0 5px',
                                                                    fontSize: 9,
                                                                    fontWeight: 800,
                                                                    lineHeight: '14px',
                                                                    minWidth: 14,
                                                                    textAlign: 'center',
                                                                    display: 'inline-block',
                                                                }}>{watchoutAlerts.length}</span>
                                                            )}
                                                        </span>
                                                    )}
                                        </button>
                                    ))}
                                </div>

                                <div className="indicator-list">
                                    {/* Riders tab */}
                                    {sidebarTab === 'riders' && (() => {
                                        return validPoints.map((p, idx) => {
                                            const isSelected = selectedRiderId === p.user_id;
                                            const color = getPendingColor(p?.non_complete_orders);

                                            return (
                                                <div
                                                    key={`list-${idx}`}
                                                    className="indicator-item"
                                                    style={{
                                                        borderColor: isSelected ? '#f59e0b' : color,
                                                        borderWidth: isSelected ? 2 : 1,
                                                        opacity: 1,
                                                        background: isSelected ? '#fefce8' : undefined,
                                                    }}
                                                    onClick={() => {
                                                        handleLocate(p?.detail?.delivery_long, p?.detail?.delivery_lat);
                                                        setSelectedRiderId(prev => prev === p.user_id ? null : p.user_id);
                                                    }}
                                                >
                                                    {p?.detail?.photo ? (
                                                        <div className="dp-avatar">
                                                            <img
                                                                src={"https://food.totalfresh.co/assets/img/delivery/" + p?.detail?.photo}
                                                                className="dp-avatar" alt=""/>
                                                        </div>
                                                    ) : (
                                                        <span className="dot" style={{backgroundColor: color}}>
                                                            {(p?.detail?.name || p?.name || "?").charAt(0)}
                                                        </span>
                                                    )}
                                                    <div className="item-info">
                                                        <div className="item-name">{p?.name}</div>
                                                        <div style={{fontSize: 11, color: '#64748b'}}>
                                                            Pending: {p?.non_complete_orders}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        });
                                    })()}

                                    {/* Orders tab */}
                                    {sidebarTab === 'orders' && formattedOrders.map((o, idx) => {
                                        const isSelected = selectedOrderId === o.id;

                                        // Build rider breakdown for this order when selected
                                        const case1Riders = isSelected
                                            ? validPoints.filter(p => riderAvailability[p.user_id]?.case === 'case1')
                                            : [];
                                        const case2Riders = isSelected
                                            ? validPoints.filter(p =>
                                                riderAvailability[p.user_id]?.case === 'case2' ||
                                                riderAvailability[p.user_id]?.case === 'case2-gps'
                                            )
                                            : [];

                                        return (
                                            <div
                                                key={`order-list-${idx}`}
                                                className="indicator-item"
                                                style={{
                                                    borderColor: isSelected ? '#6366f1' : '#e2e8f0',
                                                    borderWidth: isSelected ? 2 : 1,
                                                    background: isSelected ? '#eef2ff' : undefined,
                                                    flexDirection: 'column',
                                                    alignItems: 'stretch',
                                                    gap: 0,
                                                    padding: 0,
                                                }}
                                            >
                                                {/* Order row */}
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 10,
                                                        padding: '10px 12px',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => {
                                                        handleLocate(o.lng, o.lat);
                                                        handleOrderClick(o.id);
                                                    }}
                                                >
                                                    <span className="dot" style={{
                                                        backgroundColor: '#6366f1',
                                                        color: '#fff',
                                                        fontSize: 13,
                                                        flexShrink: 0
                                                    }}>📦</span>
                                                    <div className="item-info" style={{flex: 1, minWidth: 0}}>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: 6,
                                                            marginBottom: 2
                                                        }}>
                                                            <div className="item-name"
                                                                 style={{fontSize: 12}}>{o.restaurant}</div>
                                                            <span style={{
                                                                fontSize: 9,
                                                                fontWeight: 700,
                                                                letterSpacing: '0.05em',
                                                                textTransform: 'uppercase',
                                                                borderRadius: 10,
                                                                padding: '2px 7px',
                                                                background: o.status === 1 ? '#fef9c3' : '#e0f2fe',
                                                                color: o.status === 1 ? '#a16207' : '#0369a1',
                                                                border: `1px solid ${o.status === 1 ? '#fde68a' : '#bae6fd'}`,
                                                                flexShrink: 0,
                                                            }}>
            {o.status === 1 ? '🆕 New' : '🍳 Preparing'}
        </span>
                                                        </div>
                                                        <div style={{fontSize: 11, color: '#64748b'}}>{o.name}</div>
                                                        <div style={{fontSize: 10, color: '#94a3b8', marginTop: 1}}>
                                                            {o.address?.slice(0, 40)}{o.address?.length > 40 ? '…' : ''}
                                                        </div>
                                                        <ElapsedTimer createdAt={o.createdAt}/> {/* 👈 */}
                                                        {!isSelected && (
                                                            <div style={{fontSize: 10, color: '#a5b4fc', marginTop: 2}}>
                                                                Tap to see available riders
                                                            </div>
                                                        )}
                                                    </div>
                                                    {isSelected && (
                                                        <div style={{
                                                            flexShrink: 0,
                                                            background: availableForSelected > 0 ? '#6366f1' : '#94a3b8',
                                                            color: '#fff',
                                                            borderRadius: 20,
                                                            padding: '2px 8px',
                                                            fontSize: 11,
                                                            fontWeight: 700,
                                                        }}>
                                                            {availableForSelected}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* Inline rider availability panel */}
                                                {isSelected && (
                                                    <div style={{
                                                        borderTop: '1px solid #c7d2fe',
                                                        background: '#f5f3ff',
                                                        padding: '10px 12px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 8,
                                                    }}>
                                                        {availableForSelected === 0 ? (
                                                            <div style={{
                                                                fontSize: 11,
                                                                color: '#94a3b8',
                                                                textAlign: 'center',
                                                                padding: '4px 0'
                                                            }}>
                                                                No riders available nearby
                                                            </div>
                                                        ) : (
                                                            <>
                                                                {case1Riders.length > 0 && (
                                                                    <div>
                                                                        <div style={{
                                                                            fontSize: 10,
                                                                            fontWeight: 700,
                                                                            color: '#15803d',
                                                                            marginBottom: 5,
                                                                            letterSpacing: '0.04em',
                                                                            textTransform: 'uppercase'
                                                                        }}>
                                                                            🟢 Case 1 — Free &amp; nearby
                                                                            ({case1Riders.length})
                                                                        </div>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            flexWrap: 'wrap',
                                                                            gap: 6
                                                                        }}>
                                                                            {case1Riders.map(p => {
                                                                                const av = riderAvailability[p.user_id];
                                                                                const isAssigned = assignedMap[o.id] === p.user_id;
                                                                                const isAssigning = assigningRiderId === p.user_id;
                                                                                return (
                                                                                    <div
                                                                                        key={p.user_id}
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            gap: 5,
                                                                                            background: '#dcfce7',
                                                                                            border: '1px solid #86efac',
                                                                                            borderRadius: 20,
                                                                                            padding: '3px 6px 3px 6px',
                                                                                            fontSize: 11,
                                                                                        }}
                                                                                    >
                                                                                        {p?.detail?.photo ? (
                                                                                            <img
                                                                                                src={"https://food.totalfresh.co/assets/img/delivery/" + p.detail.photo}
                                                                                                style={{
                                                                                                    width: 18,
                                                                                                    height: 18,
                                                                                                    borderRadius: '50%',
                                                                                                    objectFit: 'cover'
                                                                                                }}
                                                                                                alt=""
                                                                                                onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
                                                                                            />
                                                                                        ) : (
                                                                                            <div
                                                                                                onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
                                                                                                style={{
                                                                                                    width: 18,
                                                                                                    height: 18,
                                                                                                    borderRadius: '50%',
                                                                                                    background: '#22c55e',
                                                                                                    color: '#fff',
                                                                                                    display: 'flex',
                                                                                                    alignItems: 'center',
                                                                                                    justifyContent: 'center',
                                                                                                    fontSize: 9,
                                                                                                    fontWeight: 700,
                                                                                                    flexShrink: 0,
                                                                                                    cursor: 'pointer',
                                                                                                }}
                                                                                            >
                                                                                                {(p?.name || '?').charAt(0)}
                                                                                            </div>
                                                                                        )}
                                                                                        <span
                                                                                            onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
                                                                                            style={{
                                                                                                color: '#15803d',
                                                                                                fontWeight: 600,
                                                                                                cursor: 'pointer'
                                                                                            }}
                                                                                        >{p?.name}</span>
                                                                                        {av?.dist && <span style={{
                                                                                            color: '#16a34a',
                                                                                            fontSize: 10
                                                                                        }}>{av.dist}km</span>}
                                                                                        <button
                                                                                            onClick={() => handleAssign(o.id, p.user_id, o.customerId)}
                                                                                            disabled={isAssigning || isAssigned}
                                                                                            style={{
                                                                                                marginLeft: 2,
                                                                                                background: isAssigned ? '#86efac' : '#22c55e',
                                                                                                color: '#fff',
                                                                                                border: 'none',
                                                                                                borderRadius: 20,
                                                                                                padding: '2px 7px',
                                                                                                fontSize: 10,
                                                                                                fontWeight: 700,
                                                                                                cursor: isAssigned ? 'default' : 'pointer',
                                                                                                opacity: isAssigning ? 0.6 : 1,
                                                                                                transition: 'all 0.15s',
                                                                                            }}
                                                                                        >
                                                                                            {isAssigned ? '✓' : isAssigning ? '...' : 'Assign'}
                                                                                        </button>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {case2Riders.length > 0 && (
                                                                    <div>
                                                                        <div style={{
                                                                            fontSize: 10,
                                                                            fontWeight: 700,
                                                                            color: '#1d4ed8',
                                                                            marginBottom: 5,
                                                                            letterSpacing: '0.04em',
                                                                            textTransform: 'uppercase'
                                                                        }}>
                                                                            🔵 Case 2 — Drop-off nearby
                                                                            ({case2Riders.length})
                                                                        </div>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            flexWrap: 'wrap',
                                                                            gap: 6
                                                                        }}>
                                                                            {case2Riders.map(p => {
                                                                                const av = riderAvailability[p.user_id];
                                                                                const isAssigned = assignedMap[o.id] === p.user_id;
                                                                                const isAssigning = assigningRiderId === p.user_id;
                                                                                return (
                                                                                    <div
                                                                                        key={p.user_id}
                                                                                        style={{
                                                                                            display: 'flex',
                                                                                            alignItems: 'center',
                                                                                            gap: 5,
                                                                                            background: '#dbeafe',
                                                                                            border: '1px solid #93c5fd',
                                                                                            borderRadius: 20,
                                                                                            padding: '3px 6px 3px 6px',
                                                                                            fontSize: 11,
                                                                                        }}
                                                                                    >
                                                                                        {p?.detail?.photo ? (
                                                                                            <img
                                                                                                src={"https://food.totalfresh.co/assets/img/delivery/" + p.detail.photo}
                                                                                                style={{
                                                                                                    width: 18,
                                                                                                    height: 18,
                                                                                                    borderRadius: '50%',
                                                                                                    objectFit: 'cover'
                                                                                                }}
                                                                                                alt=""
                                                                                                onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
                                                                                            />
                                                                                        ) : (
                                                                                            <div
                                                                                                onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
                                                                                                style={{
                                                                                                    width: 18,
                                                                                                    height: 18,
                                                                                                    borderRadius: '50%',
                                                                                                    background: '#3b82f6',
                                                                                                    color: '#fff',
                                                                                                    display: 'flex',
                                                                                                    alignItems: 'center',
                                                                                                    justifyContent: 'center',
                                                                                                    fontSize: 9,
                                                                                                    fontWeight: 700,
                                                                                                    flexShrink: 0,
                                                                                                    cursor: 'pointer',
                                                                                                }}
                                                                                            >
                                                                                                {(p?.name || '?').charAt(0)}
                                                                                            </div>
                                                                                        )}
                                                                                        <span
                                                                                            onClick={() => handleLocate(p.detail.delivery_long, p.detail.delivery_lat)}
                                                                                            style={{
                                                                                                color: '#1d4ed8',
                                                                                                fontWeight: 600,
                                                                                                cursor: 'pointer'
                                                                                            }}
                                                                                        >{p?.name}</span>
                                                                                        {av?.dropDist && <span style={{
                                                                                            color: '#2563eb',
                                                                                            fontSize: 10
                                                                                        }}>{av.dropDist}km drop</span>}
                                                                                        <button
                                                                                            onClick={() => handleAssign(o.id, p.user_id, o.customerId)}
                                                                                            disabled={isAssigning || isAssigned}
                                                                                            style={{
                                                                                                marginLeft: 2,
                                                                                                background: isAssigned ? '#93c5fd' : '#3b82f6',
                                                                                                color: '#fff',
                                                                                                border: 'none',
                                                                                                borderRadius: 20,
                                                                                                padding: '2px 7px',
                                                                                                fontSize: 10,
                                                                                                fontWeight: 700,
                                                                                                cursor: isAssigned ? 'default' : 'pointer',
                                                                                                opacity: isAssigning ? 0.6 : 1,
                                                                                                transition: 'all 0.15s',
                                                                                            }}
                                                                                        >
                                                                                            {isAssigned ? '✓' : isAssigning ? '...' : 'Assign'}
                                                                                        </button>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}

                                    {sidebarTab === 'orders' && formattedOrders.length === 0 && (
                                        <div style={{
                                            padding: 24,
                                            textAlign: 'center',
                                            color: '#94a3b8',
                                            fontSize: 13
                                        }}>No active orders</div>
                                    )}

                                    {sidebarTab === 'watch' && (
                                        <WatchTabPanel
                                            watchoutAlerts={watchoutAlerts}
                                            handleLocate={handleLocate}
                                            setSelectedRiderId={setSelectedRiderId}
                                            setSidebarTab={setSidebarTab}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TrackingMap;